import { getEnvironment, getSocketUrl } from "./environment";
import React, { useEffect, useRef, useState } from "react";
import Api from "./components/api/api";
import {
    composeLineNotes,
    emptyFilter,
    filterKey,
    isFilterActive,
    isRisky,
    lineAllergenData,
    reasonsLabel,
    riskReasons,
} from "./utils/allergenFilter";
import useIdleLogout from "./hooks/useIdleLogout";
import Login from "./components/Login";
import Loading from "./components/Loading";
import Sidebar from "./components/Sidebar";
import Lock from "./components/Lock";
import Products from "./components/menu/Products";
import Cart from "./components/cart/Cart";
import Header from "./components/Header";
import PopUp from "./components/PopUp";
import Settings from "./components/Settings";
import Confirm from "./components/confirm";
import jwt_decode from "jwt-decode";
import moment from "moment/moment";
import "./css/App.css";
import "./css/Login.css";
import "./css/Header.css";
import "./css/Sidebar.css";
import "./css/Cart.css";
import "./css/Loading.css";
import "./css/Lock.css";
import "./css/Products.css";
import "./css/PopUp.css";
import "./css/DatePopUpV2.css";
import "./css/Settings.css";
import "./css/variantsPopUp.css";
import "./css/TablesList.css";
import "./css/HeaderRight.css";
import "./css/PinPad.css";
import "./css/Notifications.css";
import "./css/menu.css";
import "./css/AlertPopup.css";
import OrdersList from "./components/OrdersList";
import AddressPopUp from "./components/AddressPopUp";
import AddressForm from "./components/AddressForm";
import Socket from "./Socket";
import { io } from "socket.io-client";
import TablesList from "./components/TablesList";
import TablePopUp from "./components/TablePopUp";
import SellsList from "./components/SellsList";
import DiscountsPopup from "./components/cart/DiscountsPopup";
import EditProductPopup from "./components/cart/EditProductPopup";
import SplitPopup from "./components/cart/SplitPopup";
import OpenTablePopup from "./components/OpenTablePopup";
import TableSelector from "./components/TableSelector";
import InvoicePopup from "./components/invoice/InvoicePopup";
import ReportsPopUp from "./components/ReportsPopUp";
import PosPaymentPopup from "./components/cart/PosPaymentPopup";
import CashPaymentPopup from "./components/cart/CashPaymentPopup";
import SatispayPopup from "./components/cart/SatispayPopup";
import VoucherlyPopup from "./components/cart/VoucherlyPopup";
import PinPad from "./components/ui/PinPad";
import Updater from "./components/Updater";
import HeaderRight from "./components/HeaderRight";
import PaymentPopup from "./components/cart/PaymentPopup";
import QrPopup from "./components/QrPopup";
import CashDrawerPopup from "./components/CashDrawerPopup";
import { v4 as uuidv4 } from "uuid";
import RestPopup from "./components/cart/RestPopup";
import QrScanPopup from "./components/QrScanPopup";
import EreciptPopupPopup from "./components/cart/EreciptPopup";
import EreciptQrPopup from "./components/cart/EreciptQrPopup";
import FidelityDiscountsPopup from "./components/cart/FidelityDiscountsPopup";
import PinLogin from "./components/PinLogin";
import EditProducts from "./components/editPopups/EditProducts";
import EditCategories from "./components/editPopups/EditCategories";
import ListCategories from "./components/editPopups/ListCategories";
import ListProducts from "./components/editPopups/ListProducts";
import GloryPopup from "./components/glory/GloryPopup";
import CashmaticPopup from "./components/cashmatic/CashmaticPopup";
import { useAppStore } from "./store/useAppStore";
import UnprintedPopup from "./components/UnprintedPopup";
import FiscalPrinterPopup from "./components/FiscalPrinterPopup";
import CashmaticWarningPopup from "./components/CashmaticWarningPopup";
import MainMenu from "./components/MainMenu";
import InventoryPopup from "./components/glory/InventoryPopup";
import FiskalyExpiringLogin from "./components/FiskalyExpiringLogin";
import MenuFlatRepository from "./menu/MenuFlatRepository";
import NewOrderAlerts from "./components/NewOrderAlerts";
import { paymentErrorSummary } from "./functions/paymentErrors";
import { emptyShopDeviceConfig, loadShopDeviceConfig, saveShopDeviceConfig } from "./utils/shopDeviceConfig";
// import ThermalPrintAlertsPopup from "./components/ThermalPrintAlertsPopup";

export const AppContext = React.createContext();

let socketUrl = getSocketUrl();
console.log("socketUrl", socketUrl);
const socket = io(socketUrl);

function mergeMenuLists(existingLists, flatLists) {
    const base = Array.isArray(existingLists) ? existingLists : [];
    const incoming = Array.isArray(flatLists) ? flatLists : [];
    const existingById = base.reduce((acc, list) => {
        acc[list.id] = list;
        return acc;
    }, {});

    const merged = incoming.map((list) => ({
        ...(existingById[list.id] || {}),
        ...list,
    }));

    for (const list of base) {
        if (!merged.find((item) => item.id === list.id)) merged.push(list);
    }

    return merged;
}

function sortByBackendPosition(items = []) {
    return [...items]
        .map((item, index) => ({ item, index }))
        .sort((a, b) => {
            const aPosition = Number(a.item?.position);
            const bPosition = Number(b.item?.position);
            const hasAPosition = Number.isFinite(aPosition);
            const hasBPosition = Number.isFinite(bPosition);

            if (hasAPosition && hasBPosition && aPosition !== bPosition) return aPosition - bPosition;
            if (hasAPosition && !hasBPosition) return -1;
            if (!hasAPosition && hasBPosition) return 1;
            return a.index - b.index;
        })
        .map(({ item }) => item);
}

// Il terminale POS Protocollo 17 si chiamava "pos_nexi_id": migra la config salvata in localStorage
function migrateLegacyPosConfig(storedConfig) {
    if (!storedConfig || !("pos_nexi_id" in storedConfig)) return storedConfig;
    const { pos_nexi_id, ...rest } = storedConfig;
    return { ...rest, pos_p17_id: rest.pos_p17_id ?? pos_nexi_id };
}

function App() {
    const [config, setConfig] = useState(
        localStorage.getItem("pos-config")
            ? migrateLegacyPosConfig(JSON.parse(localStorage.getItem("pos-config")))
            : {
                  mode: "remote",
                  product_button_height: "fixed",
                  show_product_image: 0,
                  confirm_order: 0,
                  fiscal_printer_id: null,
                  thermal_printer_id: null,
                  virtual_printer_id: null,
                  glory_id: null,
                  cashmatic_id: null,
                  pos_p17_id: null,
                  keep_open_after_checkout: 0,
                  check_fiscal_closure: 0,
                  prebill_on_checkout: 0,
                  optional_print: 0,
                  cash_drawer_closures: 0,
                  rest: 0,
                  time_selection_v2: 0,
                  orders_list_v2: 0,
                  reset_delivery_type_to_shop: 0,
                  viva_terminal_id: "",
                  dojo_terminal_id: "",
                  quick_payment_footer: 0,
                  quick_payment_method_ids: [null, null, null],
              },
    );
    const [lock, setLock] = useState(false);
    const [loading, setLoading] = useState(false);
    const [loadingForced, setLoadingForced] = useState(false);
    const [apiSettings, setApiSettings] = useState(false);
    const [settingsVisible, setSettingsVisible] = useState(false);
    const [settingsPage, setSettingsPage] = useState("main");
    const [user, setUser] = useState(false);
    const [shops, setShops] = useState(false);
    const [shop, setShop] = useState(
        localStorage.getItem("pos-shop") ? JSON.parse(localStorage.getItem("pos-shop")) : false,
    );
    const [dismissedLicenseNotice, setDismissedLicenseNotice] = useState(false);
    const [lists, setLists] = useState(false);
    const [list, setList] = useState(
        localStorage.getItem("pos-list") ? JSON.parse(localStorage.getItem("pos-list")) : false,
    );
    const [menu, setMenu] = useState(false);
    const [menuProductLookup, setMenuProductLookup] = useState({});
    const [discountsProducts, setDiscountsProducts] = useState([]);
    const [discountsAvail, setDiscountsAvail] = useState({});
    const [filteredCategories, setFilteredCategories] = useState(false);
    const [category, setCategory] = useState(false);
    const [categoryPos, setCategoryPos] = useState(false);
    const [cart, setCart] = useState(false);
    // filtro allergeni del commensale di cui si sta prendendo l'ordine: vale fino a Invia o Nuovo ordine
    const [allergenFilter, setAllergenFilter] = useState(emptyFilter());
    const [productionCenters, setProductionCenters] = useState(false);
    const [rooms, setRooms] = useState(false);
    const [tables, setTables] = useState(false);
    const [popup, setPopup] = useState(false);
    const [confirm, setConfirm] = useState(false);
    const [iframeMode, setIframeMode] = useState(false);
    const [activeFlow, setActiveFlow] = useState(1);
    const [ordersListVisible, setOrdersListVisible] = useState(false);
    const [tablesListVisible, setTablesListVisible] = useState(false);
    const [sellsListVisible, setSellsListVisible] = useState(false);
    const [orders, setOrders] = useState([]);
    const [sells, setSells] = useState([]);
    const [sellsPagination, setSellsPagination] = useState({
        pag: 1,
        per_pag: 25,
        total_records: 0,
        total_pages: 1,
    });
    const [sellsSearch, setSellsSearch] = useState("");
    const [orderByIdLoaded, setOrderByIdLoaded] = useState(false);
    const [addressPopUpVisible, setAddressPopUpVisible] = useState(false);
    const [tablePopup, setTablePopup] = useState(false);
    const [addressFormPopUpVisible, setAddressFormPopUpVisible] = useState(false);
    const [discountsPopup, setDiscountsPopup] = useState(false);
    const [editingProduct, setEditingProduct] = useState(false);
    const [splitPopup, setSplitPopup] = useState(false);
    const [posCategories, setPosCategories] = useState([]);
    const [mode, setMode] = useState(localStorage.getItem("pos-menu-mode") || 1);
    const [edited, setEdited] = useState(false);
    const [fiscalPrinters, setFiscalPrinters] = useState([]);
    const [fiscalPrinter, setFiscalPrinter] = useState(null);
    const [thermalPrinters, setThermalPrinters] = useState([]);
    const [printAgentStatus, setPrintAgentStatus] = useState(null);
    const [glories, setGlories] = useState([]);
    const [cashmatics, setCashmatics] = useState([]);
    const [posP17Terminals, setPosP17Terminals] = useState([]);
    const [openTablePopupVisible, setOpenTablePopupVisible] = useState(false);
    const [table, setTable] = useState(false);
    const [tableSelectorVisible, setTableSelectorVisible] = useState(false);
    const [invoicePopup, setInvoicePopup] = useState(false);
    const [invoiceFormPopup, setInvoiceFormPopup] = useState(false);
    const [deliveryPrice, setDeliveryPrice] = useState(0);
    const [total, setTotal] = useState(false);
    const [reportsPopUpVisible, setReportsPopUpVisible] = useState(false);
    const [posPaymentPopup, setPosPaymentPopup] = useState(false);
    const [satispayPopup, setSatispayPopup] = useState(false);
    const [voucherlyPopup, setVoucherlyPopup] = useState(false);
    const [paymentPopup, setPaymentPopup] = useState(false);
    const [ereciptPopup, setEreciptPopup] = useState(false);
    const [ereciptQrPopup, setEreciptQrPopup] = useState(false);
    const [permissions, setPermissions] = useState([]);
    const [pinPadVisible, setPinPadVisible] = useState(false);
    const [authorized, setAuthorized] = useState(false);
    const [stock, setStock] = useState([]);
    const [amount, setAmount] = useState("");
    const [command, setCommand] = useState(false);
    const [overlay, setOverlay] = useState(false);
    const [colors, setColors] = useState([]);
    const [loadingMessage, setLoadingMessage] = useState(false);
    const [loadingError, setLoadingError] = useState(false);
    const [lockEdit, setLockEdit] = useState(false);
    const [ordersFilter, setOrdersFilter] = useState(moment().format("YYYY-MM-DD"));
    const [sellsFilter, setSellsFilter] = useState(moment().format("YYYY-MM-DD"));
    const [searchTerm, setSearchTerm] = useState("");
    const [searchAddressTerm, setSearchAddressTerm] = useState("");
    const [qrPopupVisible, setQrPopupVisible] = useState(false);
    const [qrScanPopupVisible, setQrScanPopupVisible] = useState(false);
    const [fidelityDiscountsPopupVisible, setFidelityDiscountsPopupVisible] = useState(false);
    const [cashDrawerPopupVisible, setCashDrawerPopupVisible] = useState(false);
    const [restPopup, setRestPopup] = useState(false);
    const [lastOrderId, setLastOrderId] = useState(false);
    const [points, setPoints] = useState(0);
    const [pointsGained, setPointsGained] = useState(0);
    const [pointsSpent, setPointsSpent] = useState(0);
    const [posSettings, setPosSettings] = useState(false);
    const [menuOpen, setMenuOpen] = useState(false);
    const [lightMode, setLightMode] = useState(false);
    const [editMode, setEditMode] = useState(false);
    const [editProductsPopupVisible, setEditProductsPopupVisible] = useState(false);
    const [editCategoriesPopupVisible, setEditCategoriesPopupVisible] = useState(false);
    const [listCategoriesPopupVisible, setListCategoriesPopupVisible] = useState(false);
    const [listProductsPopupVisible, setListProductsPopupVisible] = useState(false);
    const [categories, setCategories] = useState([]);
    const [products, setProducts] = useState([]);
    const [selectedEditCategory, setSelectedEditCategory] = useState(false);
    const [newOrderAlerts, setNewOrderAlerts] = useState([]);
    const [thermalPrintAlerts, setThermalPrintAlerts] = useState({ rows: [], counts: {} });
    const [highlightedOrderId, setHighlightedOrderId] = useState(null);
    const [hideFiscalPrinterWarning, setHideFiscalPrinterWarning] = useState(() => {
        return localStorage.getItem("pos-hide-fiscal-printer-warning") == "1";
    });
    const [hideCashmaticWarning, setHideCashmaticWarning] = useState(() => {
        return localStorage.getItem("pos-hide-cashmatic-warning") == "1";
    });
    const lastShopIdRef = useRef(null);
    // Negozio a cui appartiene la config dispositivi attualmente in `config`
    const configShopIdRef = useRef(null);
    const initCartUserRef = useRef(null);
    const pendingAuthorizationActionRef = useRef(null);
    const ordersRef = useRef([]);
    const ordersLoadedRef = useRef(false);
    const newOrderAlertTimersRef = useRef({});
    const ordersLoadingRef = useRef(false);
    const ordersQueuedOptionsRef = useRef(null);
    const sellsLoadingRef = useRef(false);
    const sellsQueuedOptionsRef = useRef(null);
    const sellsPaginationRef = useRef(sellsPagination);
    const sellsSearchRef = useRef(sellsSearch);
    const tablesLoadingRef = useRef(false);
    const tablesQueuedRef = useRef(false);
    const thermalPrintAlertsLoadingRef = useRef(false);
    const thermalPrintAlertsQueuedRef = useRef(false);
    const socketOrdersDebounceRef = useRef(null);
    const {
        cashPaymentPopup,
        setCashPaymentPopup,
        setGlory,
        setCashmatic,
        setEnv,
        setUnprinted,
        setVirtualPrinters,
        splittedOrders,
        setSplittedOrders,
        setSplittedOrdersCount,
        round,
        setRound,
        setTotalBeforeRound,
        payed,
        unprinted,
    } = useAppStore();

    const logout = () => {
        setUser(false);
        localStorage.removeItem("pos-user");
    };

    // il banner di avviso licenza e' chiudibile ma riappare a ogni nuova sessione
    useEffect(() => {
        if (!user) setDismissedLicenseNotice(false);
    }, [user]);

    const autologoutMinutes = Number(apiSettings?.pos?.autologout_minutes ?? 0);
    useIdleLogout({
        enabled: !!user && autologoutMinutes > 0,
        timeoutMinutes: autologoutMinutes,
        onIdle: logout,
        paused: !!(posPaymentPopup || paymentPopup || cashPaymentPopup),
    });

    const delivery_types = [
        { id: "shop", name: "Sala" },
        { id: "takeaway", name: "Asporto" },
        { id: "delivery", name: "Consegna a domicilio" },
    ];
    const queryParams = new URLSearchParams(window.location.search);
    const hasShopIdParam = queryParams.has("shop_id");
    const hasFiscalPrinterIdParam = queryParams.has("fiscal_printer_id");
    const hasVirtualPrinterIdParam = queryParams.has("virtual_printer_id");
    const requestedShopId = queryParams.get("shop_id");
    const requestedFiscalPrinterId = queryParams.get("fiscal_printer_id");
    const requestedVirtualPrinterId = queryParams.get("virtual_printer_id");
    const fiscalPrinterEnabled = apiSettings?.mandant?.fiscal_printers == 1;
    const virtualPrinterEnabled = apiSettings?.mandant?.fiskaly == 1;
    const cashmaticEnabled = apiSettings?.mandant?.cashmatic == 1;
    const showCashmaticWarning =
        cashmaticEnabled &&
        !hideCashmaticWarning &&
        cashmatics.length > 0 &&
        !config?.cashmatic_id;
    const showFiscalPrinterWarning =
        (fiscalPrinterEnabled || virtualPrinterEnabled) &&
        !hideFiscalPrinterWarning &&
        !(fiscalPrinterEnabled && config?.fiscal_printer_id) &&
        !(virtualPrinterEnabled && config?.virtual_printer_id) &&
        !(
            fiscalPrinterEnabled &&
            virtualPrinterEnabled &&
            (config?.fiscal_printer_id || config?.virtual_printer_id)
        );
    const showBottomAlerts =
        showFiscalPrinterWarning ||
        showCashmaticWarning ||
        Number(unprinted || 0) > 0 ||
        newOrderAlerts.length > 0 ||
        (thermalPrintAlerts?.counts?.documents || 0) > 0;

    useEffect(() => {
        init();
    }, []);

    useEffect(() => {
        console.log("permissions set to", permissions);
    }, [permissions]);

    useEffect(() => {
        console.log("lockEdit set to", lockEdit);
    }, [lockEdit]);

    useEffect(() => {
        if (!user) initCartUserRef.current = null;
    }, [user]);

    useEffect(() => {
        // Clear temporary authorization state whenever the active user changes.
        setAuthorized(false);
        setPinPadVisible(false);
        pendingAuthorizationActionRef.current = null;
        if (!user) setPermissions([]);
    }, [user?.id]);

    useEffect(() => {
        console.log("cart set to", cart);
        if (cart && cart.list_id && Array.isArray(lists)) {
            const selectedList = lists.find((l) => l.id == cart.list_id);
            if (selectedList) setList(selectedList);
        }
    }, [cart, lists]);

    useEffect(() => {
        if (config) localStorage.setItem("pos-config", JSON.stringify(config));
        if (config && configShopIdRef.current) saveShopDeviceConfig(configShopIdRef.current, config);
    }, [config]);

    useEffect(() => {
        if (shop) localStorage.setItem("pos-shop", JSON.stringify(shop));
        else localStorage.removeItem("pos-shop");
    }, [shop]);

    useEffect(() => {
        localStorage.setItem("pos-hide-fiscal-printer-warning", hideFiscalPrinterWarning ? "1" : "0");
    }, [hideFiscalPrinterWarning]);

    useEffect(() => {
        localStorage.setItem("pos-hide-cashmatic-warning", hideCashmaticWarning ? "1" : "0");
    }, [hideCashmaticWarning]);

    useEffect(() => {
        if (!user || !shops || !lists) return;

        const shouldInitForUser = initCartUserRef.current !== user.id;
        const shouldInitMissingCart = !cart;

        if (shouldInitForUser || shouldInitMissingCart) {
            init_cart();
            initCartUserRef.current = user.id;
        }
    }, [user, shops, lists, cart]);

    useEffect(() => {
        if (user) {
            loadData();
        }
    }, [user]);

    useEffect(() => {
        console.log("orderByIdLoaded", orderByIdLoaded);
        if (menu && !orderByIdLoaded) loadOrderById(queryParams.get("order_id"));
    }, [menu]);

    useEffect(() => {
        if (apiSettings) {
            setLightMode(apiSettings.mandant.pos_light == 1);
        }
    }, [apiSettings]);

    useEffect(() => {
        if (apiSettings) {
            loadOrders();
        }
    }, [shop, apiSettings, ordersFilter]);

    useEffect(() => {
        if (apiSettings) {
            loadSells({ pag: 1 });
        }
    }, [shop, apiSettings, sellsFilter]);

    useEffect(() => {
        sellsPaginationRef.current = sellsPagination;
    }, [sellsPagination]);

    useEffect(() => {
        sellsSearchRef.current = sellsSearch;
    }, [sellsSearch]);

    useEffect(() => {}, [shop, apiSettings, ordersFilter, sellsFilter]);

    useEffect(() => {
        localStorage.setItem("pos-menu-mode", mode);
    }, [mode]);

    useEffect(() => {
        localStorage.setItem("pos-orders-filter", ordersFilter);
    }, [ordersFilter]);

    useEffect(() => {
        const res = orders.filter(
            (o) => o.yellgo_pos_id == null && o.status != "awaiting_payment" && o.status != "payment_error",
        );
        console.log("unprinted orders", res.length);
        setUnprinted(res.length);
    }, [orders]);

    useEffect(() => {
        if (!(apiSettings?.mandant?.fiscal_printers == 1 && config.check_fiscal_closure == 1)) return;
        const intervalId = window.setInterval(checkDailyClosures, 5000);
        return () => window.clearInterval(intervalId);
    }, [fiscalPrinters, config, apiSettings]);

    useEffect(() => {
        if (user && shop) {
            loadColors();
        }
    }, [user, shop]);

    useEffect(() => {
        console.log("shop set to", shop);
    }, [shop]);

    useEffect(() => {
        ordersRef.current = Array.isArray(orders) ? orders : [];
    }, [orders]);

    useEffect(() => {
        return () => {
            Object.values(newOrderAlertTimersRef.current).forEach((timer) => window.clearTimeout(timer));
            newOrderAlertTimersRef.current = {};
        };
    }, []);

    useEffect(() => {
        if (!shop?.id) return;
        if (lastShopIdRef.current === null) {
            // Primo negozio della sessione: ripristina la config salvata per questo negozio,
            // altrimenti adotta quella attuale di pos-config (prima volta / migrazione).
            lastShopIdRef.current = shop.id;
            configShopIdRef.current = shop.id;
            const saved = loadShopDeviceConfig(shop.id);
            if (!saved) {
                saveShopDeviceConfig(shop.id, config);
                return;
            }
            // I parametri in query string hanno la precedenza sulla config salvata
            if (hasFiscalPrinterIdParam) delete saved.fiscal_printer_id;
            if (hasVirtualPrinterIdParam) delete saved.virtual_printer_id;
            setConfig((prev) => ({ ...prev, ...saved }));
            return;
        }
        if (lastShopIdRef.current !== shop.id) {
            lastShopIdRef.current = shop.id;
            configShopIdRef.current = shop.id;
            setHideFiscalPrinterWarning(false);
            setHideCashmaticWarning(false);
            // Svuota le liste del negozio precedente: la validazione degli id aspetta quelle del nuovo
            setFiscalPrinters([]);
            setFiscalPrinter(null);
            setThermalPrinters([]);
            setGlories([]);
            setCashmatics([]);
            setPosP17Terminals([]);
            setConfig((prev) => ({
                ...prev,
                ...emptyShopDeviceConfig(),
                ...(loadShopDeviceConfig(shop.id) || {}),
            }));
        }
    }, [shop?.id]);

    useEffect(() => {
        if (shop && user) {
            loadFiscalPrinters();
            loadThermalPrinters();
            loadCashmaticDevices();
            loadGloryDevices();
            loadPosP17Terminals();
        }
    }, [shop, user]);

    useEffect(() => {
        if (shop && user) {
            loadPrintAgentStatus();
            const interval = setInterval(loadPrintAgentStatus, 60000);
            return () => clearInterval(interval);
        }
    }, [shop, user]);

    useEffect(() => {
        if (shop && user) {
            load_rooms();
            load_tables();
        }
    }, [shop?.id, user?.id]);

    useEffect(() => {
        console.log("setFiscalPrinter", fiscalPrinters, config.fiscal_printer_id);
        if (config.fiscal_printer_id) {
            if (fiscalPrinters.length === 0) return;
            const fp = fiscalPrinters.find((fp) => fp.id == config.fiscal_printer_id);
            if (fp) setFiscalPrinter(fp);
            else setConfig((prev) => ({ ...prev, fiscal_printer_id: null }));
        }
    }, [fiscalPrinters, config.fiscal_printer_id]);

    useEffect(() => {
        console.log("fiscalPrinter set to", fiscalPrinter);
    }, [fiscalPrinter]);

    useEffect(() => {
        if (cart.customer?.id) load_points();
    }, [cart.customer]);

    useEffect(() => {
        if (!cart || apiSettings?.pos?.enable_discount_customer != 1) return;
        if (cart.customer) return;
        const filtered = (cart.discounts || []).filter(d => d.type !== "customer_discount");
        if (filtered.length !== (cart.discounts || []).length) {
            setCart(c => ({ ...c, discounts: filtered }));
        }
    }, [cart?.customer?.id]);

    useEffect(() => {
        if (!cart || apiSettings?.pos?.enable_discount_customer != 1) return;
        if (!cart.customer) return;
        const nCart = applyCustomerDiscountToCart({ ...cart }, cart.customer);
        if (JSON.stringify(nCart.discounts) !== JSON.stringify(cart.discounts)) {
            setCart(c => ({ ...c, discounts: nCart.discounts }));
        }
    }, [cart?.delivery_type?.id, cart?.table?.id]);

    useEffect(() => {
        if (config.glory_id) {
            if (glories.length === 0) return;
            const glory = glories.find((g) => g.id == config.glory_id);
            if (glory) setGlory(glory);
            else setConfig((prev) => ({ ...prev, glory_id: null }));
        }
    }, [glories, config.glory_id]);

    useEffect(() => {
        if (config.cashmatic_id) {
            if (cashmatics.length === 0) return;
            const cashmatic = cashmatics.find((c) => c.id == config.cashmatic_id);
            if (cashmatic) setCashmatic(cashmatic);
            else setConfig((prev) => ({ ...prev, cashmatic_id: null }));
        }
    }, [cashmatics, config.cashmatic_id]);

    useEffect(() => {
        if (!config.thermal_printer_id || thermalPrinters.length === 0) return;
        if (!thermalPrinters.some((p) => p.id == config.thermal_printer_id)) {
            setConfig((prev) => ({ ...prev, thermal_printer_id: null }));
        }
    }, [thermalPrinters, config.thermal_printer_id]);

    useEffect(() => {
        if (!config.pos_p17_id || posP17Terminals.length === 0) return;
        if (!posP17Terminals.some((t) => t.id == config.pos_p17_id)) {
            setConfig((prev) => ({ ...prev, pos_p17_id: null }));
        }
    }, [posP17Terminals, config.pos_p17_id]);

    useEffect(() => {
        updateCashRound();
    }, [round, payed]);

    async function init() {
        try {
            if (!localStorage.getItem("pos-id")) localStorage.setItem("pos-id", uuidv4());
            console.log("init");
            setLoadingMessage("Avvio");
            setLock(true);
            applyQueryParamOverrides();
            loadEnv();
            Api.setBaseUrl(config);
            setLoadingMessage("Loading Settings");
            await load_pos_settings();
            setLoadingMessage("Loading Shops");
            await load_shops();
            setLoadingMessage("Loading Lists");
            await load_lists();
            setLoadingMessage("Loading User");
            await restore_user();
            setLock(false);
        } catch (error) {
            console.log(error);
            setLoadingError(error.message);
        }
    }

    async function loadData() {
        try {
            console.log("loadData");
            setLock(true);
            setLoadingMessage("Loading Settings");
            const settings = await load_settings();
            console.log("settings", settings);
            setLoadingMessage("Loading Productions Centers");
            await load_production_centers();
            setLoadingMessage("Loading Rooms");
            await load_rooms();
            setLoadingMessage("Loading Tables");
            await load_tables();
            setLoadingMessage("Loading Pos Categories");
            await load_pos_categories();
            setLoadingMessage("Loading Menu");
            await load_menu();
            setLoadingMessage("Loading Stock");
            await load_products_stock();
            if (settings.mandant.fiskaly == 1) {
                setLoadingMessage("Loading Virtual Printers");
                await loadVirtualPrinters(settings);
            }
            setLoadingMessage("Loading Glory Devices");
            await loadGloryDevices();
            setLoadingMessage("Loading Cashmatic Devices");
            await loadCashmaticDevices();
            setLoadingMessage("Loading POS Protocollo 17 Terminals");
            await loadPosP17Terminals();
            setLock(false);
        } catch (error) {
            console.log(error);
            setLoadingError(error.message);
        }
    }

    async function loadOrderById(orderId) {
        if (!orderId) return;
        console.log("loadOrderById", orderId);
        setLoading(true);
        const response = await Api.getProtected("/orders/get/" + orderId + "/");
        if (response.success == 0) alert(response.error);
        else openOrder(response.data);
        setLoading(false);
        setOrderByIdLoaded(true);
    }

    async function restore_user() {
        if (queryParams.get("token")) {
            // aperto in iframe dal backoffice tramite l'SSO (/sso/?redirect_url=...): il token arriva nell'URL e va tolto subito
            setIframeMode(true);
            const ssoToken = queryParams.get("token");
            const url = new URL(window.location.href);
            url.searchParams.delete("token");
            url.searchParams.delete("lang");
            window.history.replaceState(null, "", url.toString());
            const refresh = await Api.refreshToken(ssoToken);
            if (refresh.success == 0) alert(refresh.error);
            else {
                localStorage.setItem("pos-user", refresh.token);
                const decoded = jwt_decode(refresh.token);
                const response = await Api.getProtected("/users/get/" + decoded.user_id + "/");
                if (response.success == 0) alert(response.error);
                else {
                    setUser(response.data);
                    setPermissions(response.data.role.pos_permissions);
                }
            }
        } else {
            const token = localStorage.getItem("pos-user");
            if (token) {
                const refresh = await Api.refreshToken(token);
                if (refresh.success == 0) alert(refresh.error);
                else {
                    localStorage.setItem("pos-user", refresh.token);
                    const decoded = jwt_decode(refresh.token);
                    const response = await Api.getProtected("/users/get/" + decoded.user_id + "/");
                    if (response.success == 0) alert(response.error);
                    else {
                        setUser(response.data);
                        setPermissions(response.data.role.pos_permissions);
                    }
                }
            }
        }
    }

    async function load_pos_settings() {
        const response = await Api.post("/pos2/settings/");
        if (response.success == 0) alert(response.error);
        else setPosSettings(response.data);
    }

    async function load_settings() {
        console.log("load_settings");
        const response = await Api.post("/settings2/get/", {
            section: ["global", "orders", "google", "pos", "menu_api", "customers", "fidelity", "credit"],
        });
        if (response.success == 0) alert(response.error);
        else {
            setApiSettings(response.data);
            console.log("settings", response.data);
            return response.data;
        }
    }

    async function load_shops() {
        const response = await Api.post("/pos2/shops/", { user_id: user.id });
        if (response.success == 0) alert(response.error);
        setShops(response.rows);
        if (hasShopIdParam) {
            if (!requestedShopId) setShop(false);
            else {
                const requestedShop = response.rows.find((s) => String(s.id) === String(requestedShopId));
                setShop(requestedShop || false);
            }
        } else if (response.rows.length == 1) setShop(response.rows[0]);
        else if (shop) {
            const newData = response.rows.find((s) => s.id == shop.id);
            if (newData) setShop(newData);
        }
    }

    function applyQueryParamOverrides() {
        if (hasShopIdParam) {
            if (!requestedShopId) setShop(false);
            else localStorage.removeItem("pos-shop");
        }

        if (hasFiscalPrinterIdParam) {
            setConfig((prev) => ({
                ...prev,
                fiscal_printer_id: requestedFiscalPrinterId || null,
            }));
        }

        if (hasVirtualPrinterIdParam) {
            setConfig((prev) => ({
                ...prev,
                virtual_printer_id: requestedVirtualPrinterId || null,
            }));
        }
    }

    async function load_production_centers() {
        const response = await Api.get("/pos2/production_centers/");
        if (response.success == 0) alert(response.error);
        setProductionCenters(response.rows);
    }

    async function load_rooms() {
        const response = await Api.get("/pos2/rooms/");
        if (response.success == 0) alert(response.error);
        else {
            const filtered = sortByBackendPosition(response.rows.filter((r) => r.shop_id == shop.id));
            setRooms(filtered);
        }
    }

    async function load_tables() {
        if (tablesLoadingRef.current) {
            tablesQueuedRef.current = true;
            return;
        }

        tablesLoadingRef.current = true;
        console.log("load_tables");
        try {
            const response = await Api.post("/pos2/tables/");
            if (response.success == 0) alert(response.error);
            else setTables(response.rows);
        } catch (error) {
            alert(error.message);
        } finally {
            tablesLoadingRef.current = false;
            if (tablesQueuedRef.current) {
                tablesQueuedRef.current = false;
                load_tables();
            }
        }
    }

    async function load_lists() {
        const response = await Api.post("/lists/list/", { orderby: "position" });
        if (response.success == 0) alert(response.error);
        else setLists(response.rows);
    }

    async function load_products_stock() {
        const response = await Api.postProtected("/products_stock/list_for_clients/");
        if (response.success == 0) alert(response.error);
        else setStock(response);
    }

    async function loadFiscalPrinters() {
        const response = await Api.postProtected("/fiscal_printers/list/", {
            src: [
                { name: "active", value: 1, compare: "equal" },
                { name: "shop_id", value: shop.id, compare: "equal" },
            ],
        });
        if (response.success == 0) alert(response.error);
        else setFiscalPrinters(response.rows);
    }

    async function loadThermalPrinters() {
        const response = await Api.postProtected("/thermal_printers/list/", {
            src: [
                { name: "active", value: 1, compare: "equal" },
                { name: "shop_id", value: shop.id, compare: "equal" },
            ],
        });
        if (response.success == 0) alert(response.error);
        else setThermalPrinters(response.rows);
    }

    async function loadPrintAgentStatus() {
        const response = await Api.postProtected("/heartbeat/get/", {
            shop_id: shop.id,
        });
        if (response.success == 0) setPrintAgentStatus(null);
        else setPrintAgentStatus(response.data);
    }

    async function loadVirtualPrinters(settingsOverride = null) {
        const fiskalyEnabled = (settingsOverride || apiSettings)?.mandant?.fiskaly == 1;
        if (!fiskalyEnabled) {
            setVirtualPrinters([]);
            return;
        }

        const response = await Api.postProtected("/virtual_pos/list/");
        if (response.success == 0) {
            console.log("loadVirtualPrinters error", response.error);
            setVirtualPrinters([]);
        } else setVirtualPrinters(response.rows);
    }

    async function loadGloryDevices() {
        const response = await Api.postProtected("/glory/list/", {
            src: [
                { name: "active", value: 1, compare: "equal" },
                { name: "shop_id", value: shop.id, compare: "equal" },
            ],
        });
        if (response.success == 0) alert(response.error);
        else setGlories(response.rows);
    }

    async function loadCashmaticDevices() {
        const response = await Api.postProtected("/cashmatic/list/", {
            src: [
                { name: "active", value: 1, compare: "equal" },
                { name: "shop_id", value: shop.id, compare: "equal" },
            ],
        });
        if (response.success == 0) alert(response.error);
        else setCashmatics(response.rows);
    }

    async function loadPosP17Terminals() {
        const response = await Api.postProtected("/pos_p17/list/", {
            src: [
                { name: "active", value: 1, compare: "equal" },
                { name: "shop_id", value: shop.id, compare: "equal" },
            ],
        });
        if (response.success == 0) alert(response.error);
        else setPosP17Terminals(response.rows);
    }

    async function loadColors() {
        const response = await Api.postProtected("/pos2/colors/", {
            shop_id: shop.id,
        });
        if (response.success == 0) alert(response.error);
        else setColors(response.rows);
    }

    async function load_pos_categories() {
        const response = await Api.postProtected("/pos_categories/list/", {
            orderby: "position",
            src: [{ name: "active", value: 1, compare: "equal" }],
        });
        if (response.success == 0) alert(response.error);
        else {
            setPosCategories(response.rows);
            if (!categoryPos && response.rows.length > 0) setCategoryPos(response.rows[0]);
        }
    }

    async function load_menu() {
        console.log("load_menu");
        console.log("menu endpoint mode", "flat");

        try {
            const cachedMenu = MenuFlatRepository.loadFromCache();
            if (cachedMenu) {
                setMenu(cachedMenu.menu);
                setMenuProductLookup(cachedMenu.productLookup);
                setDiscountsProducts(cachedMenu.discountsProducts || []);
                setLists((prev) => mergeMenuLists(prev, cachedMenu.lists));
            }
        } catch (error) {
            console.warn("Unable to restore menu flat cache", error);
        }

        const adaptedMenu = await MenuFlatRepository.load({ api: Api });
        setLoading(false);
        setMenu(adaptedMenu.menu);
        setMenuProductLookup(adaptedMenu.productLookup);
        setDiscountsProducts(adaptedMenu.discountsProducts || []);
        setLists((prev) => mergeMenuLists(prev, adaptedMenu.lists));
        await loadDiscountsAvailability(adaptedMenu.discountsProducts || []);
    }

    // Quantita' residua degli sconti-prodotto a quantita' limitata (le regole statiche arrivano col menu)
    async function loadDiscountsAvailability(rules) {
        try {
            if (!rules.some((rule) => rule.has_qty_limit == 1)) return;
            const res = await Api.postProtected("/discounts_products/availability/", {});
            if (res?.success == 0) return;
            const avail = {};
            for (const row of res.rows || []) avail[row.id] = row.qty;
            setDiscountsAvail(avail);
        } catch (error) {
            console.warn("Unable to load discounts availability", error);
        }
    }

    const getOriginLabel = (origin) => {
        const map = {
            pos: "POS",
            website: "Website",
            selfordering: "Self Ordering",
            kiosk: "Kiosk",
            waiter: "Waiter",
            menu: "Menu",
            backend: "Backend",
            glovo: "Glovo",
            deliveroo: "Deliveroo",
            justeat: "Just Eat",
            ubereats: "Uber Eats",
            tracking: "Tracking",
            kitchenmonitor: "Kitchen Monitor",
            storedisplay: "Store Display",
        };
        const key = String(origin || "").trim();
        if (map[key]) return map[key];
        return key
            .split("_")
            .filter(Boolean)
            .map((part) => part.charAt(0).toUpperCase() + part.slice(1))
            .join(" ");
    };

    const removeNewOrderAlert = (alertId) => {
        setNewOrderAlerts((prev) => prev.filter((alert) => alert.alertId !== alertId));
        const timer = newOrderAlertTimersRef.current[alertId];
        if (timer) {
            window.clearTimeout(timer);
            delete newOrderAlertTimersRef.current[alertId];
        }
    };

    const handleNewOrderAlertClick = (alert) => {
        if (!alert) return;
        removeNewOrderAlert(alert.alertId);
        setHighlightedOrderId(Number(alert.orderId));
        setOrdersListVisible(true);
    };

    const pushNewOrderAlerts = (incomingOrders = []) => {
        if (!Array.isArray(incomingOrders) || incomingOrders.length === 0) return;

        setNewOrderAlerts((prev) => {
            const next = [...prev];

            incomingOrders.forEach((order) => {
                const orderId = Number(order?.id);
                if (!Number.isFinite(orderId)) return;

                const alertId = "new-order-" + orderId;
                if (next.some((item) => item.alertId === alertId)) return;

                next.push({
                    alertId,
                    orderId,
                    originLabel: getOriginLabel(order?.origin),
                });

                const timer = window.setTimeout(() => removeNewOrderAlert(alertId), 5000);
                newOrderAlertTimersRef.current[alertId] = timer;
            });

            return next;
        });
    };

    async function loadOrders(options = {}) {
        if (ordersLoadingRef.current) {
            ordersQueuedOptionsRef.current = {
                detectNewAlerts:
                    !!ordersQueuedOptionsRef.current?.detectNewAlerts || !!options.detectNewAlerts,
            };
            return;
        }
        if (!shop) return;

        ordersLoadingRef.current = true;
        console.log("loadOrders");
        const { detectNewAlerts = false } = options;
        let request = {
            shop_id: shop.id,
            filter: ordersFilter,
        };
        try {
            const endpoint = config.orders_list_v2 ? "/pos2/orders_new/" : "/pos2/orders/";
            const res = await Api.postProtected(endpoint, request);
            if (res.success == 0) alert(res.error);
            else {
                setLoading(false);
                if (detectNewAlerts && ordersLoadedRef.current) {
                    const previousIds = new Set(
                        (ordersRef.current || []).map((order) => Number(order?.id)).filter(Number.isFinite),
                    );
                    const newRows = (res.rows || []).filter((order) => !previousIds.has(Number(order?.id)));
                    pushNewOrderAlerts(newRows);
                }
                setOrders(res.rows);
                ordersLoadedRef.current = true;
            }
        } catch (error) {
            alert(error.message);
        } finally {
            ordersLoadingRef.current = false;
            if (ordersQueuedOptionsRef.current) {
                const queuedOptions = ordersQueuedOptionsRef.current;
                ordersQueuedOptionsRef.current = null;
                loadOrders(queuedOptions);
            }
        }
    }

    async function loadSells(options = {}) {
        if (sellsLoadingRef.current) {
            sellsQueuedOptionsRef.current = {
                ...(sellsQueuedOptionsRef.current || {}),
                ...options,
            };
            return;
        }
        if (!shop) return;

        sellsLoadingRef.current = true;
        console.log("loadSells");
        const pag = options.pag || sellsPaginationRef.current.pag || 1;
        const per_pag = options.per_pag || sellsPaginationRef.current.per_pag || 25;
        const search = options.search !== undefined ? options.search : sellsSearchRef.current;
        let request = {
            shop_id: shop.id,
            filter: sellsFilter,
            pag,
            per_pag,
            search,
        };
        try {
            const res = await Api.postProtected("/pos2/sells/", request);
            if (res.success == 0) alert(res.error);
            else {
                setSells(res.rows);
                if (res.pagination) {
                    const nextPagination = {
                        pag: parseInt(res.pagination.pag || pag),
                        per_pag: parseInt(res.pagination.per_pag || per_pag),
                        total_records: parseInt(res.pagination.total_records || 0),
                        total_pages: parseInt(res.pagination.total_pages || 1),
                    };
                    sellsPaginationRef.current = nextPagination;
                    setSellsPagination(nextPagination);
                }
            }
        } catch (error) {
            alert(error.message);
        } finally {
            sellsLoadingRef.current = false;
            if (sellsQueuedOptionsRef.current) {
                const queuedOptions = sellsQueuedOptionsRef.current;
                sellsQueuedOptionsRef.current = null;
                loadSells(queuedOptions);
            }
        }
    }

    function isArchivedThermalPrintOrder(row) {
        if (row?.source === "sell") return false;
        const status = String(row?.status || row?.order_status || row?.document_status || "")
            .trim()
            .toLowerCase();
        return status === "archived";
    }

    function getThermalPrintAlertsCounts(rows) {
        const printerIds = new Set();

        rows.forEach((row) => {
            const failures = Array.isArray(row?.failures) ? row.failures : [];
            failures.forEach((failure) => {
                const printerId =
                    failure?.thermal_printer_id ||
                    failure?.printer_id ||
                    failure?.printer_name ||
                    failure?.printer_ip;
                if (printerId) printerIds.add(printerId);
            });
        });

        return {
            documents: rows.length,
            printers: printerIds.size,
        };
    }

    async function loadThermalPrintAlerts() {
        if (thermalPrintAlertsLoadingRef.current) {
            thermalPrintAlertsQueuedRef.current = true;
            return;
        }
        if (!shop) return;

        thermalPrintAlertsLoadingRef.current = true;
        console.log("loadThermalPrintAlerts");
        const request = {
            shop_id: shop.id,
        };
        try {
            const res = await Api.postProtected("/pos2/thermal_print_alerts/", request);
            if (res.success == 0) {
                console.log("loadThermalPrintAlerts error", res.error);
                setThermalPrintAlerts({ rows: [], counts: {} });
            } else {
                const rows = (Array.isArray(res.rows) ? res.rows : []).filter(
                    (row) => !isArchivedThermalPrintOrder(row),
                );
                setThermalPrintAlerts({
                    rows,
                    counts: {
                        ...(res.counts || {}),
                        ...getThermalPrintAlertsCounts(rows),
                    },
                });
            }
        } catch (error) {
            console.log("loadThermalPrintAlerts error", error.message);
            setThermalPrintAlerts({ rows: [], counts: {} });
        } finally {
            thermalPrintAlertsLoadingRef.current = false;
            if (thermalPrintAlertsQueuedRef.current) {
                thermalPrintAlertsQueuedRef.current = false;
                loadThermalPrintAlerts();
            }
        }
    }

    const refreshOrdersState = async (options = {}) => {
        await Promise.allSettled([loadOrders(options), loadSells(), load_tables()]);
    };

    const editTable = async (id, request) => {
        console.log("editTable", id, request);
        const res = await Api.postProtected("/tables/edit/" + id + "/", request);
        if (res.success == 0) alert(res.error);
        else return res.data;
    };

    const allergenFilterEnabled = Number(apiSettings?.pos?.enable_allergen_filter) === 1;

    function resetAllergenFilter() {
        setAllergenFilter(emptyFilter());
    }

    function init_cart(data = {}) {
        const delivery_type = JSON.parse(localStorage.getItem("pos-delivery_type"));

        resetAllergenFilter();
        setEdited(false);
        setLockEdit(false);
        setSearchTerm("");
        setSearchAddressTerm("");
        setPoints(0);

        const newCart = {
            ...{
                order_id: false,
                covers: 1,
                origin: "pos",
                status: "confirmed",
                customer: false,
                name: "",
                surname: "",
                area_code: null,
                mobile: null,
                email: null,
                notes: "",
                address: null,
                delivery_date: null,
                delivery_time_range: null,
                delivery_order: null,
                shop_id: shop ? shop.id : null,
                list_id: list ? list.id : null,
                room_id: null,
                table: null,
                delivery_type:
                    delivery_type && !config.reset_delivery_type_to_shop
                        ? delivery_type
                        : { id: "shop", name: "Sala" },
                driver_id: null,
                products: [],
                discounts: [],
                credit_total: 0,
                user_id: user.id,
                invoice: 0,
                bill: 0,
                payments: [],
            },
            ...data,
        };

        setCart(newCart);
    }

    function editCart2(data) {
        console.log("editCart2", data);
        let nCart = { ...cart, ...data };
        setCart(nCart);
        //setEdited(true);
    }

    function getEmptyTableCartData(currentCart = cart) {
        if (!currentCart?.table || currentCart?.delivery_type?.id != "shop") return null;

        return {
            list_id: currentCart.table.list_id ?? currentCart.list_id ?? null,
            table: currentCart.table,
            room_id: currentCart.table.room_id ?? currentCart.room_id ?? null,
            delivery_type: {
                id: "shop",
                name: "Sala",
            },
            delivery_date: null,
            address: false,
            delivery_time_range: null,
            self_cart_id: currentCart.self_cart_id || currentCart.table.cart_id || null,
        };
    }

    function getProductIndex(product) {
        const i = cart.products.findIndex((p) => {
            let same = false;
            // le righe in omaggio restano separate: un nuovo pezzo dello stesso prodotto si paga
            if (p.id == product.id && p.flow == activeFlow && p.price == product.price && !p.gift) same = true;
            // con il filtro allergeni abilitato restano separate le righe con allergia o note diverse
            if (allergenFilterEnabled) {
                if (filterKey(p.allergy_filter) !== filterKey(product.allergy_filter)) same = false;
                if ((p.notes || "") !== (product.notes || "")) same = false;
            }
            for (const vc1 of p.variants_categories) {
                for (const vc2 of product.variants_categories) {
                    if (vc1.id == vc2.id) {
                        for (const v1 of vc1.variants) {
                            for (const v2 of vc2.variants) {
                                if (v1.id == v2.id) {
                                    if (v1.qty != v2.qty) same = false;
                                }
                            }
                        }
                        for (const v1 of vc1.variants2) {
                            for (const v2 of vc2.variants2) {
                                if (v1.id == v2.id) {
                                    if (v1.qty != v2.qty) same = false;
                                }
                            }
                        }
                        for (const v1 of vc1.products) {
                            for (const v2 of vc2.products) {
                                if (v1.id == v2.id) {
                                    if (v1.qty != v2.qty) same = false;
                                }
                            }
                        }
                        for (const v1 of vc1.products2) {
                            for (const v2 of vc2.products2) {
                                if (v1.id == v2.id) {
                                    if (v1.qty != v2.qty) same = false;
                                }
                            }
                        }
                    }
                }
            }
            for (const i1 of p.ingredients) {
                for (const i2 of product.ingredients) {
                    if (i1.id == i2.id) {
                        if (i1.removed != i2.removed) same = false;
                    }
                }
            }
            return same;
        });
        return i;
    }

    // keepDiscount: il prezzo passato include solo gli extra delle varianti (popup), non e' un prezzo digitato dall'operatore
    function add_product(product, price = false, keepDiscount = false) {
        let nCart = structuredClone(cart);

        let newP = structuredClone(product);
        if (allergenFilterEnabled) {
            // rete di sicurezza per gli inserimenti che non passano dalla griglia (ricerca, preferiti, popup)
            const filterOn = isFilterActive(allergenFilter);
            const risky = filterOn ? riskReasons(newP, allergenFilter) : [];
            for (const vc of newP.variants_categories || [])
                for (const group of ["products", "products2"])
                    for (const item of vc[group] || [])
                        if (filterOn && item.qty > 0 && isRisky(item, allergenFilter))
                            risky.push(...riskReasons(item, allergenFilter));
            if (risky.length) {
                setConfirm({
                    title: "Filtro allergie",
                    message: newP.name + " contiene: " + reasonsLabel(risky) + ". Spegni il filtro per aggiungerlo.",
                });
                return;
            }
            Object.assign(newP, lineAllergenData(newP, allergenFilter));
        }
        if (price) newP.price = price;
        newP = getKeypadInfo(newP);
        newP.flow = activeFlow;

        // prezzo modificato a mano dall'operatore: non e' piu' lo sconto-prodotto
        if (newP.discounts_products_id && !keepDiscount && newP.price != product.price) stripProductDiscount(newP);

        for (const part of splitDiscountedProduct(newP)) {
            const i = getProductIndex(part);
            console.log(i);

            if (i >= 0) nCart.products[i].qty = parseFloat(nCart.products[i].qty) + part.qty;
            else {
                nCart.products.unshift(part);
            }
        }
        console.log(nCart);
        setEdited(true);
        setCart(nCart);
        setAmount("");
        setCommand(false);
    }

    function stripProductDiscount(product) {
        if (product.discount_amount !== undefined) product.price = Math.round((parseFloat(product.price) + product.discount_amount) * 100) / 100;
        else if (product.original_price !== undefined) product.price = product.original_price;
        delete product.original_price;
        delete product.discount_amount;
        delete product.discounted;
        delete product.discounts_products_id;
        return product;
    }

    // Sconto-prodotto a quantita' limitata: i pezzi scontati non possono superare la quantita' residua (meno quelli gia' nel
    // carrello). L'eccedenza viene aggiunta come riga a prezzo pieno. Il server ricontrolla comunque in products_stock/check.
    function splitDiscountedProduct(product) {
        if (!product.discounts_products_id) return [product];
        const rule = discountsProducts.find((r) => r.id == product.discounts_products_id);
        if (!rule || rule.has_qty_limit != 1) return [product];

        const inCart = cart.products
            .filter((p) => p.discounts_products_id == product.discounts_products_id)
            .reduce((sum, p) => sum + parseFloat(p.qty), 0);
        const residual = Math.max(0, (discountsAvail[rule.id] ?? 0) - inCart);
        const qty = parseFloat(product.qty);
        if (residual >= qty) return [product];

        const parts = [];
        if (residual > 0) parts.push({ ...product, qty: residual });
        parts.push(stripProductDiscount({ ...product, qty: qty - residual }));
        return parts;
    }

    // Se la quantita' residua cambia (socket, ricarica dopo un errore) le righe scontate oltre il residuo tornano a prezzo pieno.
    useEffect(() => {
        if (!cart.products?.some((p) => p.discounts_products_id)) return;
        const remaining = {};
        const products = [];
        const changedNames = [];
        let changed = false;
        for (const p of cart.products) {
            const rule = p.discounts_products_id && discountsProducts.find((r) => r.id == p.discounts_products_id);
            if (!rule || rule.has_qty_limit != 1) {
                products.push(p);
                continue;
            }
            if (remaining[rule.id] === undefined) remaining[rule.id] = Number(discountsAvail[rule.id] ?? 0);
            const qty = parseFloat(p.qty);
            const keep = Math.min(qty, remaining[rule.id]);
            remaining[rule.id] -= keep;
            if (keep >= qty) {
                products.push(p);
                continue;
            }
            changed = true;
            if (!changedNames.includes(p.name)) changedNames.push(p.name);
            if (keep > 0) products.push({ ...p, qty: keep });
            products.push(stripProductDiscount({ ...p, qty: qty - keep }));
        }
        if (changed) {
            setCart((prev) => ({ ...prev, products }));
            setConfirm({
                title: "Attenzione",
                message: changedNames.map((n) => "Il prodotto " + n + " non è più disponibile con prezzo scontato - è stato aggiornato").join("\n"),
            });
        }
    }, [discountsAvail]);

    function getKeypadInfo(product) {
        product.qty = 1;
        if (amount) {
            if (command === "multi") {
                product.qty = parseFloat(amount);
            }
            const isPriceCommand =
                command === false ||
                command === "" ||
                command === "minus" ||
                command === "percminus" ||
                command === "percplus";
            if (isPriceCommand && hasPosPermission("products_prices", "edit", false)) {
                if (command === false || command === "") {
                    product.price = parseFloat(amount);
                }
                if (command === "minus") {
                    product.price = parseFloat(product.price) - parseFloat(amount);
                }
                if (command === "percminus") {
                    product.price =
                        parseFloat(product.price) - (parseFloat(product.price) / 100) * parseFloat(amount);
                }
                if (command === "percplus") {
                    product.price =
                        parseFloat(product.price) + (parseFloat(product.price) / 100) * parseFloat(amount);
                }
            }
        }
        return product;
    }

    async function openOrder(order) {
        console.log(order);
        resetAllergenFilter();
        setEdited(false);
        setList(order.list_id || false);
        setLockEdit(["glovo", "deliveroo", "justeat"].includes(order.origin));

        let customerCredit = 0;
        let customerPoints = 0;
        if (order.customer_id) {
            const balRes = await Api.getProtected("/pos2/customer_balance/" + order.customer_id + "/");
            if (balRes?.success !== 0) {
                customerCredit = balRes.credit || 0;
                customerPoints = balRes.points || 0;
            }
        }

        setCart({
            order_id: order.id,
            covers: order.covers,
            origin: order.origin,
            status: order.status,
            customer:
                order.customer_id || order.email
                    ? {
                          id: order.customer_id,
                          name: order.name,
                          surname: order.surname,
                          email: order.email,
                          area_code: order.area_code,
                          mobile: order.mobile,
                          credit: customerCredit,
                          points: customerPoints,
                      }
                    : false,
            name: order.name || "",
            surname: order.surname || "",
            area_code: order.area_code || null,
            mobile: order.mobile || null,
            email: order.email || null,
            notes: order.notes || "",
            address: order.delivery_address
                ? {
                      ...order.delivery_address,
                      ...{
                          polygon_id: order.polygon_id,
                          delivery_price: order && order.delivery_price ? order.delivery_price : 0,
                          delivery_free_min: order.polygon?.delivery_free_min || null,
                      },
                  }
                : null,
            delivery_date: order.delivery_date,
            delivery_time_range: order.delivery_time_range,
            delivery_order: order.delivery_order ? Number(order.delivery_order) : null,
            shop_id: order.shop_id,
            list_id: order.list_id,
            room_id: order.room_id ?? null,
            room: order.room_id ? order.room : null,
            table: order.table_id ? order.table : null,
            self_cart_id: order.self_cart_id,
            driver_id: order.driver_id ? Number(order.driver_id) : null,
            delivery_type: delivery_types.filter((dt) => dt.id == order.delivery_type)[0],
            products: formatProducts(order.products),
            discounts: formatDiscounts(order.discounts),
            user_id: order.user_id,
            payment_method: order.payment_method,
            payment_method_id: order.payment_method_id,
            credit_total: order.credit_total,
            payments: normalizePayments(order.payments),
            pointsGained: order.fidelity_points_gained,
            pointsSpent: order.fidelity_points_used,
        });
    }

    function formatProducts(products) {
        let res = [];
        for (const p of products) {
            const loadMeta = resolveProductLoadMeta(p);
            const el = {
                id: p.product_id,
                item_id: p.id,
                uuid: p.uuid,
                product_id: p.product_id,
                name: p.name,
                qty: p.qty,
                price: p.price ?? 0,
                gift: p.gift == 1 ? 1 : 0,
                gift_price: p.gift == 1 && p.gift_price != null ? parseFloat(p.gift_price) : null,
                notes: p.notes,
                variants_categories: formatVariantsCategories(p.product_id, p.variants, p.products),
                flow: p.flow ? p.flow : 1,
                size: loadMeta.size,
                driver_size: loadMeta.driver_size,
                printed: [],
                ingredients: [],
            };
            res.push(el);
        }
        return res;
    }

    function resolveProductLoadMeta(orderProduct) {
        const sizeFromOrder = Number(orderProduct?.size);
        const driverSizeFromOrder = Number(orderProduct?.driver_size);
        if (Number.isFinite(sizeFromOrder) || Number.isFinite(driverSizeFromOrder)) {
            return {
                size: Number.isFinite(sizeFromOrder) ? sizeFromOrder : 0,
                driver_size: Number.isFinite(driverSizeFromOrder) ? driverSizeFromOrder : 0,
            };
        }

        let menuProduct = null;
        menuProduct = menuProductLookup[orderProduct?.product_id] || null;

        return {
            size: Number(menuProduct?.size) || 0,
            driver_size: Number(menuProduct?.driver_size) || 0,
        };
    }

    function formatVariantsCategories(productId, variants, subproducts) {
        const originaProduct = menuProductLookup[productId];
        //console.log("originaProduct", originaProduct);
        if (originaProduct?.variants_categories) {
            const variantsCategories = structuredClone(originaProduct.variants_categories);
            variantsCategories.forEach((variants_category) => {
                let selected = 0;
                variants_category.variants.forEach((variant) => {
                    variant.qty = 0;
                    variants.forEach((v) => {
                        if (v.variant_category_id == variants_category.id && v.variant_id == variant.id) {
                            variant.qty = v.qty;
                            selected++;
                        }
                    });
                });
                variants_category.variants2.forEach((variant) => {
                    variant.qty = 0;
                    variants.forEach((v) => {
                        if (v.variant_category_id == variants_category.id && v.variant_id == variant.id) {
                            variant.qty = v.qty;
                            selected++;
                        }
                    });
                });
                variants_category.products.forEach((subproduct) => {
                    subproduct.qty = 0;
                    subproducts.forEach((s) => {
                        if (s.variant_category_id == variants_category.id && s.product_id == subproduct.id) {
                            subproduct.qty = s.qty;
                            selected++;
                        }
                    });
                });
                variants_category.products2.forEach((subproduct) => {
                    subproduct.qty = 0;
                    subproducts.forEach((s) => {
                        if (s.variant_category_id == variants_category.id && s.product_id == subproduct.id) {
                            subproduct.qty = s.qty;
                            selected++;
                        }
                    });
                });
                variants_category.selected = selected;
            });
            return variantsCategories;
        } else return [];
    }

    function formatDiscounts(discounts) {
        let res = [];
        for (const d of discounts) {
            const el = {
                ...d,
                value: toNumber(d.value),
                price: toNumber(d.price),
            };
            res.push(el);
        }
        return res;
    }

    function toNumber(value) {
        if (value === null || value === undefined || value === "") return 0;
        if (typeof value === "number") return Number.isFinite(value) ? value : 0;
        const normalized = String(value).trim().replace(/\s+/g, "").replace(",", ".");
        const n = Number(normalized);
        return Number.isFinite(n) ? n : 0;
    }

    function getCustomerDiscountField(deliveryTypeId, table) {
        if (deliveryTypeId === "delivery") return "discount_delivery";
        if (deliveryTypeId === "takeaway") return "discount_takeaway";
        if (deliveryTypeId === "shop" && table) return "discount_table";
        return "discount_shop";
    }

    function applyCustomerDiscountToCart(nCart, customer) {
        nCart.discounts = nCart.discounts.filter(d => d.type !== "customer_discount");
        if (!customer || apiSettings?.pos?.enable_discount_customer != 1) return nCart;
        const field = getCustomerDiscountField(nCart.delivery_type?.id, nCart.table);
        const value = toNumber(customer[field]);
        if (value > 0) {
            nCart.discounts = [...nCart.discounts, {
                name: `Sconto cliente (${value}%)`,
                type: "customer_discount",
                value_type: "perc",
                value: value,
            }];
        }
        return nCart;
    }

    function selectCustomer(customer, extraData = {}) {
        let nCart = { ...cart, ...extraData, customer };
        nCart = applyCustomerDiscountToCart(nCart, customer);
        setCart(nCart);
        setEdited(true);
    }

    async function updateCartCustomerBalance() {
        const id = cart.customer?.id;
        if (!id) return;
        const balRes = await Api.getProtected("/pos2/customer_balance/" + id + "/");
        if (balRes?.success !== 0) {
            setCart(prev => ({
                ...prev,
                customer: {
                    ...prev.customer,
                    credit: balRes.credit || 0,
                    points: balRes.points || 0,
                },
            }));
        }
    }

    function normalizePayments(payments = []) {
        return payments.map((p) => {
            const payment_method_id =
                p.payment_method_id === null || p.payment_method_id === undefined
                    ? p.payment_method_id
                    : Number(p.payment_method_id);
            const amount = toNumber(p.amount);
            let o_amount = toNumber(p.o_amount);

            if (payment_method_id == 1 && o_amount == 0 && amount > 0) {
                o_amount = amount;
            }

            return {
                ...p,
                payment_method_id,
                amount,
                o_amount,
            };
        });
    }

    function mapPaymentsForApi(payments = []) {
        return payments
            .map((p) => {
                const payment_method_id =
                    p.payment_method_id === null || p.payment_method_id === undefined
                        ? p.payment_method_id
                        : Number(p.payment_method_id);
                const amount = toNumber(p.amount);
                const o_amount = toNumber(p.o_amount);

                if (payment_method_id == 1) {
                    if (amount <= 0) return null;

                    return {
                        ...p,
                        payment_method_id,
                        amount: o_amount > 0 ? o_amount : amount,
                        o_amount,
                    };
                }

                return {
                    ...p,
                    payment_method_id,
                    amount,
                    o_amount,
                };
            })
            .filter(Boolean);
    }

    function normalizeDriverId(value) {
        if (value === null || value === undefined || value === "") return null;
        const n = Number(value);
        return Number.isFinite(n) && n > 0 ? n : null;
    }

    function normalizeDeliveryOrder(value) {
        if (value === null || value === undefined || value === "") return null;
        const n = Number(value);
        return Number.isFinite(n) && n > 0 ? Math.floor(n) : null;
    }

    const checkout = async (
        reopen = false,
        payment_method = false,
        print_bill = false,
        requestPosPayment = false,
        print_prebill = false,
        data = {},
    ) => {
        console.log("checkout");
        setLoading(true);
        const disableStockCheckPos = apiSettings?.menu_api?.disable_stock_check_operators == 1;
        // con il controllo stock disattivato resta attivo quello sugli sconti-prodotto (il server salta lo stock)
        if (!disableStockCheckPos || cart.products.some((p) => p.discounts_products_id)) {
            const stockCheck = await Api.postProtected("/products_stock/check/", {
                products: cart.products,
                shop_id: cart.shop_id,
            });
            if (stockCheck.success == 0) {
                loadDiscountsAvailability(discountsProducts);
                setLoading(false);
                setConfirm({
                    title: "Errore",
                    message: stockCheck.error,
                });
                return false;
            }
        }

        // Pagamento misto contanti + carta con cassa automatica (Glory/Cashmatic): prima la cassa incassa la quota
        // contanti, poi l'agente rimette l'ordine in awaiting_payment e passa al terminale per la quota carta.
        const mixedCashAndCard =
            (config.glory_id || config.cashmatic_id) &&
            cart.payments.find((p) => p.payment_method_id == 1) &&
            cart.payments.find((p) => p.payment_method_id == 14);

        if (cart.payments.find((p) => p.payment_method_id == 14) && !mixedCashAndCard) {
            print_bill = false;
            requestPosPayment = true;
        }

        if (cart.payments.find((p) => p.payment_method_id == 20)) {
            print_bill = false;
            requestPosPayment = true;
        }

        if (cart.payments.find((p) => p.payment_method_id == 22)) {
            print_bill = false;
            requestPosPayment = true;
        }

        if (cart.payments.find((p) => p.payment_method_id == 23)) {
            print_bill = false;
            requestPosPayment = true;
        }

        let requestSatispayPayment = false;
        if (
            cart.payments.find((p) => p.payment_method_id == 8) &&
            shop?.payment_methods?.find((m) => m.id == 8)?.account_id
        ) {
            requestSatispayPayment = true;
        }

        // Le righe con gateway sono quote già incassate da Voucherly (pagamento parziale): non riaprono il QR
        let requestVoucherlyPayment = false;
        if (cart.payments.find((p) => p.payment_method_id == 21 && !p.gateway)) {
            requestVoucherlyPayment = true;
        }

        let requestCashPayment = false;
        if ((print_bill || mixedCashAndCard) && (config.glory_id || config.cashmatic_id) && cart.payments.find((p) => p.payment_method_id == 1)) {
            print_bill = false;
            requestCashPayment = true;
        }

        let order = { ...cart, products: [], ...data };
        if (payment_method) order.payment_method_id = payment_method.id;
        if (!order.delivery_date) order.delivery_date = moment().format("YYYY-MM-DD HH:mm:ss");
        if (order.table?.id) order.table_id = order.table.id;
        order.room_id = order.room_id ?? order.room?.id ?? null;
        if (requestPosPayment) order.status = "awaiting_payment";
        if (requestSatispayPayment) order.status = "awaiting_payment";
        if (requestVoucherlyPayment) order.status = "awaiting_payment";
        if (requestCashPayment) order.status = "awaiting_cash_payment";
        if (order.customer) {
            order.customer_id = order.customer.id;
            order.name = order.customer.name;
            order.surname = order.customer.surname;
            order.area_code = order.customer.area_code;
            order.mobile = order.customer.mobile;
            order.email = order.customer.email;
        } else {
            order.customer_id = null;
            order.name = order.name ? String(order.name).trim() : null;
            order.surname = order.surname ? String(order.surname).trim() : null;
            order.area_code = order.area_code || null;
            order.mobile = order.mobile || null;
            order.email = order.email || null;
        }
        order.delivery_type = order.delivery_type.id;
        order.driver_id = normalizeDriverId(order.driver_id);
        order.delivery_order = normalizeDeliveryOrder(order.delivery_order);
        if (Array.isArray(order.delivery_ordering)) order.delivery_ordering = order.delivery_ordering;
        else order.delivery_ordering = null;
        order.polygon_id = order.address?.polygon_id ? order.address.polygon_id : null;
        order.delivery_price = deliveryPrice;
        order.round = round;
        order.total = total;
        order.fiscal_printer_id = config.fiscal_printer_id || null;
        order.thermal_printer_id = config.thermal_printer_id || null;
        order.virtual_printer_id = config.virtual_printer_id || null;
        order.glory_id = config.glory_id || null;
        order.cashmatic_id = config.cashmatic_id || null;
        order.pos_p17_id = config.pos_p17_id || null;
        delete order.table;
        delete order.customer;
        delete order.order_id;
        if (order.payments.length > 0) {
            order.payment_method_id = order.payments[0].id;
        }
        order.payments = mapPaymentsForApi(order.payments || []);

        for (const p of cart.products) {
            order.products.push({
                product_id: p.id,
                name: p.name,
                qty: p.qty,
                price: p.price ?? 0,
                gift: p.gift ? 1 : 0,
                gift_price: p.gift ? p.gift_price : null,
                discounts_products_id: p.discounts_products_id ?? null,
                notes: composeLineNotes(p, {
                    ingredientsNotes: prepareIngredients(p.ingredients),
                    withAllergenInfo: allergenFilterEnabled,
                }),
                flow: p.flow,
                size: p.size,
                driver_size: p.driver_size,
                variants: prepareVariants(p.variants_categories),
                products: prepareProducts(p.variants_categories),
            });
        }

        if (print_bill) {
            order.bill = 1;
        }

        if (print_prebill) {
            order.prebill_request = 1;
            order.prebill_printed = 0;
        }

        const res = await Api.postProtected("/orders/add/", order);
        setLoading(false);
        if (res.success == 1) {
            resetAllergenFilter();
            setLastOrderId(res.data.id);
            refreshOrdersState();
            if (requestPosPayment) {
                setPosPaymentPopup({ data: res.data, edit: false });
            } else if (requestSatispayPayment) {
                setSatispayPopup({ data: res.data, edit: false });
            } else if (requestVoucherlyPayment) {
                setVoucherlyPopup({ data: res.data, edit: false });
            } else if (requestCashPayment) {
                setCashPaymentPopup({ data: res.data, edit: false });
            } else {
                const reopenTableCartData = reopen ? getEmptyTableCartData() : null;
                if (reopenTableCartData) {
                    init_cart(reopenTableCartData);
                    setActiveFlow(parseInt(cart.table?.flow) + 1 || 1);
                } else {
                    init_cart();
                }
                window.parent.postMessage("close", "*");
                if (reopen && !reopenTableCartData) openOrder(res.data);
            }
        } else
            setConfirm({
                title: "Errore",
                message: res.error,
            });
    };

    // Conto diviso: dopo il pagamento di una parte apre la successiva ("Ordine X di N").
    // Chiamata anche dai popup di pagamento (terminale, Satispay, Voucherly, contanti, Dojo) a pagamento riuscito.
    const loadNextSplittedOrder = () => {
        if (splittedOrders.length == 0) return;
        const newList = splittedOrders.slice(1);
        loadOrderById(newList[0]);
        setSplittedOrders(newList);
        if (newList.length == 0) setSplittedOrdersCount(0);
    };

    const updateOrderFromCart = async (
        payment_method = false,
        print_bill = false,
        print_prebill = false,
        requestPosPayment = false,
        data = {},
    ) => {
        console.log("updateOrderFromCart");

        // Pagamento misto contanti + carta con cassa automatica (Glory/Cashmatic): prima la cassa incassa la quota
        // contanti, poi l'agente rimette l'ordine in awaiting_payment e passa al terminale per la quota carta.
        const mixedCashAndCard =
            (config.glory_id || config.cashmatic_id) &&
            cart.payments.find((p) => p.payment_method_id == 1) &&
            cart.payments.find((p) => p.payment_method_id == 14);

        if (cart.payments.find((p) => p.payment_method_id == 14) && !mixedCashAndCard) {
            print_bill = false;
            requestPosPayment = true;
        }

        if (cart.payments.find((p) => p.payment_method_id == 20)) {
            print_bill = false;
            requestPosPayment = true;
        }

        if (cart.payments.find((p) => p.payment_method_id == 22)) {
            print_bill = false;
            requestPosPayment = true;
        }

        if (cart.payments.find((p) => p.payment_method_id == 23)) {
            print_bill = false;
            requestPosPayment = true;
        }

        let requestSatispayPayment = false;
        if (
            cart.payments.find((p) => p.payment_method_id == 8) &&
            shop?.payment_methods?.find((m) => m.id == 8)?.account_id
        ) {
            requestSatispayPayment = true;
        }

        // Le righe con gateway sono quote già incassate da Voucherly (pagamento parziale): non riaprono il QR
        let requestVoucherlyPayment = false;
        if (cart.payments.find((p) => p.payment_method_id == 21 && !p.gateway)) {
            requestVoucherlyPayment = true;
        }

        let requestCashPayment = false;
        if ((print_bill || mixedCashAndCard) && (config.glory_id || config.cashmatic_id) && cart.payments.find((p) => p.payment_method_id == 1)) {
            print_bill = false;
            requestCashPayment = true;
        }
        console.log("requestPosPayment", requestPosPayment);
        console.log("requestCashPayment", requestCashPayment);

        let order = {
            user_id: user.id,
            delivery_type: cart.delivery_type.id,
            delivery_date: cart.delivery_date ?? moment().format("YYYY-MM-DD HH:mm:ss"),
            delivery_time_range: cart.delivery_time_range,
            delivery_order: normalizeDeliveryOrder(cart.delivery_order),
            delivery_ordering: Array.isArray(cart.delivery_ordering) ? cart.delivery_ordering : null,
            delivery_price: deliveryPrice,
            table_id: cart.table?.id ? cart.table.id : null,
            room_id: cart.room_id ?? (cart.room?.id ? cart.room.id : null),
            self_cart_id: cart.self_cart_id ? cart.self_cart_id : null,
            driver_id: normalizeDriverId(cart.driver_id),
            covers: cart.covers,
            round: round,
            total: total,
            notes: cart.notes,
            products: [],
            discounts: cart.discounts,
            invoice: cart.invoice,
            billing_address: cart.billing_address || null,
            thermal_printer_id: config.thermal_printer_id || null,
            virtual_printer_id: config.virtual_printer_id || null,
            fiscal_printer_id: config.fiscal_printer_id || null,
            glory_id: config.glory_id || null,
            cashmatic_id: config.cashmatic_id || null,
            pos_p17_id: config.pos_p17_id || null,
            payments: mapPaymentsForApi(cart.payments || []),
            credit_total: cart.credit_total || 0,
        };
        order = { ...order, ...data };

        if (payment_method) order.payment_method_id = payment_method.id;

        if (requestPosPayment) order.status = "awaiting_payment";
        else if (requestSatispayPayment) order.status = "awaiting_payment";
        else if (requestVoucherlyPayment) order.status = "awaiting_payment";
        else if (requestCashPayment) {
            order.status = "awaiting_cash_payment";
            // Pulisce l'esito di un eventuale tentativo cassa precedente sullo stesso ordine,
            // altrimenti il popup lo leggerebbe alla riapertura e si comporterebbe di conseguenza.
            order.cashmatic_error = null;
            order.glory_error = null;
        }
        else if (cart.payments.length > 0 && !["preparation", "ready", "filled"].includes(cart.status)) order.status = "confirmed";

        if (config.confirm_order == 1 && cart.status == "unconfirmed") order.status = "confirmed";

        if (cart.customer) {
            order.customer_id = cart.customer.id;
            order.name = cart.customer.name;
            order.surname = cart.customer.surname;
            order.area_code = cart.customer.area_code;
            order.mobile = cart.customer.mobile;
            order.email = cart.customer.email;
        } else {
            order.customer_id = null;
            order.name = cart.name ? String(cart.name).trim() : null;
            order.surname = cart.surname ? String(cart.surname).trim() : null;
            order.area_code = cart.area_code || null;
            order.mobile = cart.mobile || null;
            order.email = cart.email || null;
        }

        if (cart.address) order.address = cart.address;
        else order.address = null;

        for (const p of cart.products) {
            order.products.push({
                id: p.item_id,
                product_id: p.id,
                name: p.name,
                qty: p.qty,
                price: p.price ?? 0,
                gift: p.gift ? 1 : 0,
                gift_price: p.gift ? p.gift_price : null,
                // riga nata dividendo una riga gia' salvata: l'API le copia stato KDS e stampa
                split_from_id: p.split_from_id ?? null,
                discounts_products_id: p.discounts_products_id ?? null,
                notes: composeLineNotes(p, {
                    ingredientsNotes: prepareIngredients(p.ingredients),
                    withAllergenInfo: allergenFilterEnabled,
                }),
                flow: p.flow,
                size: p.size,
                driver_size: p.driver_size,
                variants: prepareVariants(p.variants_categories),
                products: prepareProducts(p.variants_categories),
            });
        }

        if (print_bill) {
            order.bill = 1;
        }

        if (print_prebill) {
            order.prebill_request = 1;
            order.prebill_printed = 0;
        }

        setLoading(true);
        const res = await Api.postProtected("/orders/edit/" + cart.order_id + "/", order);
        setLoading(false);
        if (res.success == 1) {
            resetAllergenFilter();
            setLastOrderId(res.data.id);
            refreshOrdersState();
            if (requestPosPayment) {
                setPosPaymentPopup({ data: res.data, edit: true });
            } else if (requestSatispayPayment) {
                setSatispayPopup({ data: res.data, edit: true });
            } else if (requestVoucherlyPayment) {
                setVoucherlyPopup({ data: res.data, edit: true });
            } else if (requestCashPayment) {
                setCashPaymentPopup({ data: res.data, edit: true, previousStatus: cart.status });
            } else if (print_prebill && !print_bill) {
                // Solo stampa preconto durante l'editing: l'ordine resta aperto nel
                // carrello, risincronizzato con i dati salvati (id prodotti, stato
                // produzione) invece di svuotare il carrello come un checkout finale.
                openOrder(res.data);
            } else {
                init_cart();
                loadNextSplittedOrder();
                window.parent.postMessage("close", "*");
            }
        } else
            setConfirm({
                title: "Errore",
                message: res.error,
            });
    };

    const prepareVariants = (vcs) => {
        let res = [];
        for (const vc of vcs) {
            for (const v of vc.variants) {
                if (v.qty && v.qty > 0)
                    res.push({
                        variant_category_id: vc.id,
                        variant_id: v.id,
                        name: v.name,
                        qty: v.qty,
                        price: v.price,
                    });
            }
            for (const v of vc.variants2) {
                if (v.qty > 0 || vc.force_mono == 1)
                    res.push({
                        variant_category_id: vc.id,
                        variant_id: v.id,
                        name: v.name,
                        qty: v.qty,
                        price: v.price,
                    });
            }
        }
        return res;
    };

    const prepareProducts = (vcs) => {
        let res = [];
        for (const vc of vcs) {
            for (const v of vc.products) {
                if (v.qty && v.qty > 0)
                    res.push({
                        variant_category_id: vc.id,
                        product_id: v.id,
                        name: v.name,
                        qty: v.qty,
                        price: v.price,
                    });
            }
            for (const v of vc.products2) {
                if (v.qty && v.qty > 0)
                    res.push({
                        variant_category_id: vc.id,
                        product_id: v.id,
                        name: v.name,
                        qty: v.qty,
                        price: v.price,
                    });
            }
        }
        return res;
    };

    const prepareIngredients = (ingredients) => {
        let response = "";
        for (const ingredient of ingredients) {
            if (ingredient.removed) response += "No " + ingredient.name + "\n";
        }
        return response;
    };

    function checkDailyClosures() {
        console.log("checkDailyClosures");
        for (const p of fiscalPrinters) {
            if (!p.last_daily_closure)
                setConfirm({
                    title: "Attenzione",
                    message:
                        "E' necessario effettuare la chisura giornaliera della stampante (" + p.name + ")",
                    onConfirm: async () => {
                        const res = await Api.postProtected("/fiscal_printers/send_command/", {
                            command: "DAILY_FISCAL_CLOUSE",
                            fiscal_printer_id: p.id,
                        });
                        loadFiscalPrinters();
                        if (res.success == 0)
                            setConfirm({
                                title: "Errore",
                                message: res.error,
                            });
                    },
                });
        }
    }

    function handleSocketEvent(type, data) {
        console.log("handleSocketEvent", type);
        const shouldReloadMenu = [
            "menu",
            "categories",
            "products",
            "courses",
            "variants",
            "variants_categories",
            "prices",
            "assortment",
        ].includes(type);
        if (type == "settings") load_settings();
        if (type == "shops") load_shops();
        if (type == "rooms") load_rooms();
        if (type == "tables" || type == "orders") {
            const opts = type == "orders" ? { detectNewAlerts: true } : {};
            clearTimeout(socketOrdersDebounceRef.current);
            socketOrdersDebounceRef.current = setTimeout(() => refreshOrdersState(opts), 800);
        }
        if (type == "pos_categories") load_pos_categories();
        if (type == "thermal_printers") loadThermalPrinters();
        if (type == "fiscal_printers") loadFiscalPrinters();
        if (type == "users") refresh_user();
        if (type == "roles") refresh_user();
        if (shouldReloadMenu) load_menu();
        if (type == "products_stock") load_products_stock();
        if (type == "discounts_products" && data?.id !== undefined) {
            setDiscountsAvail((prev) => ({ ...prev, [data.id]: data.qty }));
        }
        if (type == "pos_colors") loadColors();
        if (type == "glory") loadGloryDevices();
        if (type == "cashmatic") loadCashmaticDevices();
        if (type == "pos_p17") loadPosP17Terminals();
        if (type == "notifications") showNotification(data);
    }

    const showNotification = (data) => {
        const container = document.getElementById("notifications");
        const notification = document.createElement("div");
        notification.id = data.id;
        notification.classList.add(data.type);

        const header = document.createElement("div");
        header.classList.add("notifications-header");

        const titleContainer = document.createElement("div");
        titleContainer.classList.add("title");
        const title = document.createTextNode(data.title);
        titleContainer.appendChild(title);
        header.appendChild(titleContainer);

        const closeButton = document.createElement("button");
        closeButton.type = "button";
        closeButton.setAttribute("aria-label", "Chiudi");
        closeButton.addEventListener("click", () => notification.remove());
        closeButton.appendChild(document.createTextNode("×"));
        header.appendChild(closeButton);

        notification.appendChild(header);

        // errori di pagamento: l'API invia il codice scritto dall'agente, il testo lo compone il client
        const notificationText = data.payment_error_code
            ? `Ordine ${data.order_id}: ${paymentErrorSummary(data)}`
            : data.message;
        if (notificationText) {
            const messageContainer = document.createElement("div");
            messageContainer.classList.add("message");
            const message = document.createTextNode(notificationText);
            messageContainer.appendChild(message);
            notification.appendChild(messageContainer);
        }

        if (!container) return;
        // stesso id già a schermo (evento socket ripetuto): sostituisco invece di duplicare
        if (data.id) document.getElementById(data.id)?.remove();
        container.appendChild(notification);
        // notification.remove() è no-op se l'utente l'ha già chiusa con la X
        window.setTimeout(() => notification.remove(), data.type == "info" ? 3000 : 10000);
    };

    const updateOrder = async (order, request) => {
        console.log("updateOrder");
        setLoading(true);
        const res = await Api.postProtected("/orders/edit/" + order.id + "/?debug=1", {
            ...request,
            thermal_printer_id: config.thermal_printer_id || null,
            virtual_printer_id: config.virtual_printer_id || null,
        });
        if (res.success == 0) {
            setLoading(false);
            setConfirm({
                title: "Errore",
                message: res.error,
            });
        } else {
            refreshOrdersState();
            return res.data;
        }
    };

    const hasPosPermission = (table, fun, defaultIfMissing = true) => {
        if (!user?.role) return false;
        if (user.role.id == -1) return true;
        const tablePermissions = permissions?.[table];
        if (!tablePermissions || tablePermissions[fun] === undefined) return defaultIfMissing;
        return tablePermissions[fun] == 1;
    };

    const checkPermission = (table, fun) => {
        console.log("checkPermission", user.role);
        if (authorized) {
            setAuthorized(false);
            return true;
        }
        return hasPosPermission(table, fun);
    };

    const askPermission = (action = null) => {
        console.log("askPermission");
        pendingAuthorizationActionRef.current = typeof action === "function" ? action : null;
        setPinPadVisible(true);
    };

    const checkPin = async (pin) => {
        console.log("checkPin");
        const response = await Api.postProtected("/pos2/check_pin/", { pin: pin });
        if (response.success == 0)
            setConfirm({
                title: "Errore",
                message: response.error,
            });
        else {
            setPinPadVisible(false);
            const pendingAction = pendingAuthorizationActionRef.current;
            pendingAuthorizationActionRef.current = null;
            if (pendingAction) await pendingAction();
            else setAuthorized(true);
        }
    };

    const refresh_user = async () => {
        if (user) {
            const response = await Api.getProtected("/users/get/" + user.id + "/");
            if (response.success == 0) alert(response.error);
            else setPermissions(response.data.role.pos_permissions);
        }
    };

    async function load_points() {
        const response = await Api.postProtected("/pos2/points/", {
            customer_id: cart.customer.id,
            shop_id: shop.id,
        });
        if (response.success == 0) alert(response.error);
        else setPoints(response.points);
    }

    function toggleSubmenu() {
        if (menuOpen) {
            setMenuOpen(false);
        } else {
            setMenuOpen(true);
            setOverlay({
                action: () => {
                    setMenuOpen(false);
                    setOverlay(false);
                },
            });
        }
    }

    const sendCommand = async (type = "DAILY_FINANCIAL_REPORT") => {
        console.log("sendCommand");

        setConfirm({
            title: "Sei sicuro?",
            onConfirm: async () => {
                setOverlay(false);
                const res = await Api.postProtected("/fiscal_printers/send_command/", {
                    fiscal_printer_id: config.fiscal_printer_id,
                    command: type,
                });
                if (res.success == 0)
                    setConfirm({
                        title: "Errore",
                        message: res.error,
                    });
            },
        });
    };

    const sendLocalCommand = async (command, data = null) => {
        console.log("sendLocalCommand", command, data);

        const res = await Api.postProtected("/thermal_printers/send_command/", {
            shop_id: shop.id,
            command: command,
            data: data,
        });
        if (res.success == 0)
            setConfirm({
                title: "Errore",
                message: res.error,
            });
    };

    const loadCategories = async (withLoading = true) => {
        if (withLoading) setLoading(true);
        const res = await Api.postProtected("/categories/list/", {
            fields: ["id", "name", "active", "active_pos", "position"],
            orderby: "position",
        });
        if (withLoading) setLoading(false);
        if (res.success == 0)
            setConfirm({
                title: "Errore",
                message: res.error,
            });
        else setCategories(res.rows);
    };

    const loadProducts = async (withLoading = true) => {
        if (withLoading) setLoading(true);
        const res = await Api.postProtected("/products/list/", {
            fields: ["id", "name", "active", "price", "department_id", "category_id", "position"],
            orderby: "position,name",
            src: [{ name: "category_id", value: selectedEditCategory, compare: "equal" }],
        });
        if (withLoading) setLoading(false);
        if (res.success == 0)
            setConfirm({
                title: "Errore",
                message: res.error,
            });
        else setProducts(res.rows);
    };

    const loadEnv = function () {
        setEnv(getEnvironment());
    };

    const calculateTotal = () => {
        //console.log("calculateTotal");
        let total = 0;
        for (const product of cart.products) {
            total += toNumber(product.qty) * toNumber(product.price);
        }
        for (let index = 0; index < cart.discounts.length; index++) {
            const discountValue = toNumber(cart.discounts[index].value);
            if (cart.discounts[index].value_type == "perc" || cart.discounts[index].value_type == "percent") {
                const val = roundNumberByMode((total / 100) * discountValue, 2, 1);
                total -= val;
                cart.discounts[index].price = val;
            } else {
                let val = discountValue;
                if (val > total) val = total;
                total -= val;
                cart.discounts[index].price = val;
            }
        }
        console.log(
            "delivery_price",
            cart.delivery_type.id,
            cart.address?.delivery_free_min,
            cart.address?.delivery_price,
        );
        let delivery = 0;
        if (cart.delivery_type.id == "delivery" && cart.address) {
            delivery = toNumber(cart.address.delivery_price);
            if (cart.address.delivery_free_min && total >= toNumber(cart.address.delivery_free_min))
                delivery = 0;
        }
        if (cart.credit_total) total -= toNumber(cart.credit_total);
        total += toNumber(delivery);

        total = roundNumberByMode(total, 2, 1);
        const round = calculateRound(total);
        setTotalBeforeRound(total);
        total += round;

        setDeliveryPrice(delivery);
        setRound(round);
        setTotal(total);
    };

    const calculateRoundForTotal = (total, forceCash = false) => {
        if (cart.origin == "glovo" || cart.origin == "deliveroo" || cart.origin == "justeat") return 0;
        if (!forceCash && !cart.payments.find((p) => p.payment_method_id == 1)) return 0;
        const orderRound = Number(apiSettings.pos.order_round);
        const mode = Number(apiSettings.pos.order_round_mode);

        let target = total;

        switch (orderRound) {
            case 2: // Round to 0.1
                target = roundNumberByMode(total, 1, mode);
                break;

            case 3: // Round to whole number
                target = roundNumberByMode(total, 0, mode);
                break;

            case 4: // Round to nearest 0.05
                target = roundNumberByMode(Math.round(total / 0.05) * 0.05, 2, mode);
                break;

            default:
                return 0;
        }

        const round = roundNumberByMode(target - total);
        console.log(total, target, round);

        return round;
    };

    const calculateRound = (total) => calculateRoundForTotal(total, false);

    const isErecipt = (payments = cart.payments) => {
        const isTraining = payments.some((p) => p.payment_method_id == 16);
        if (isTraining) return false;
        if (fiscalPrinter && fiscalPrinter.erecipt == 1) return true;
        if (config.virtual_printer_id) return true;
        return false;
    };

    const roundNumberByMode = (number, decimals = 2, mode = 1) => {
        const multiplier = Math.pow(10, decimals);

        let n = number * multiplier;

        if (mode === 1) n = Math.round(n);
        else if (mode === 2) n = Math.ceil(n);
        else if (mode === 3) n = Math.floor(n);

        return parseFloat((n / multiplier).toFixed(decimals));
    };

    const updateCashRound = () => {
        if (!cart) return;

        setCart((prevCart) => {
            const payments = prevCart.payments;
            const cashPayments = payments.filter((p) => p.payment_method_id === 1);

            // 0 contanti -> NON fare nulla
            if (cashPayments.length === 0) return prevCart;

            const toCents = (v) => Math.round(Number(v) * 100);
            const baseCents = toCents(Number(total) - Number(round));
            const totalCents = toCents(total);
            const cashOriginalCents = cashPayments.reduce((s, p) => s + toCents(p.o_amount), 0);
            const cashAmountCents = cashPayments.reduce((s, p) => s + toCents(p.amount), 0);

            const shouldAdjustForRound = round !== 0 && cashOriginalCents === baseCents;
            const shouldAlignOriginalToRound = shouldAdjustForRound && cashAmountCents === cashOriginalCents;
            const shouldReset =
                round === 0 && cashAmountCents !== cashOriginalCents && cashOriginalCents === totalCents;

            if (!shouldAdjustForRound && !shouldReset) return prevCart;

            const lastCash = cashPayments[cashPayments.length - 1];

            return {
                ...prevCart,
                payments: payments.map((p) => {
                    if (p.payment_method_id !== 1) return p;

                    if (shouldReset) {
                        return {
                            ...p,
                            amount: p.o_amount,
                        };
                    }

                    if (p !== lastCash) {
                        return {
                            ...p,
                            amount: p.o_amount,
                        };
                    }

                    return {
                        ...p,
                        amount: Number((p.o_amount + Number(round)).toFixed(2)),
                        o_amount: shouldAlignOriginalToRound
                            ? Number((p.o_amount + Number(round)).toFixed(2))
                            : p.o_amount,
                    };
                }),
            };
        });
    };

    const licenseExpiredShop = !!(shop && shop.license_expired);
    const licenseExpiredAllShops = !shop && !!shops && shops.length > 0 && shops.every((s) => s.license_expired);
    const licenseSwitchableShops = licenseExpiredShop
        ? (shops || []).filter(
              (s) =>
                  !s.license_expired &&
                  s.id != shop.id &&
                  (!user?.shops?.length || user.shops.find((us) => us.id == s.id)),
          )
        : [];
    const licenseNoticeKey = shop ? shop.id + ":" + shop.license_threshold : null;
    const licenseNoticeVisible =
        !!user && !!shop && !shop.license_expired && !!shop.license_notice && dismissedLicenseNotice !== licenseNoticeKey;

    // il banner e' fisso in alto: lascia spazio al layout invece di coprire l'header
    useEffect(() => {
        const root = document.getElementById("root");
        if (!root) return;
        root.classList.toggle("has-license-notice", licenseNoticeVisible);
        return () => root.classList.remove("has-license-notice");
    }, [licenseNoticeVisible]);

    const switchShopAfterLicenseExpired = (newShop) => {
        setShop(newShop);
        setList(false);
        if (user) {
            editCart2({
                shop_id: newShop.id,
                list_id: null,
            });
            if (cart?.table)
                editTable(cart.table.id, {
                    list_id: null,
                });
        }
    };

    const licenseExpiredDays = (s) => Math.abs(parseInt(s?.license_diff_days) || 0);

    return (
        <>
            {apiSettings && shop && (
                <Socket
                    socket={socket}
                    mandantId={apiSettings.mandant.id}
                    onMessage={handleSocketEvent}
                    shop={shop}
                />
            )}
            <AppContext.Provider
                value={{
                    user,
                    setUser,
                    logout,
                    permissions,
                    setPermissions,
                    shop,
                    setShop,
                    list,
                    setList,
                    menu,
                    discountsProducts,
                    discountsAvail,
                    category,
                    setCategory,
                    cart,
                    setCart,
                    add_product,
                    init_cart,
                    allergenFilter,
                    setAllergenFilter,
                    allergenFilterEnabled,
                    delivery_types,
                    setPopup,
                    lists,
                    shops,
                    rooms,
                    tables,
                    setSettingsVisible,
                    settingsPage,
                    setSettingsPage,
                    filteredCategories,
                    setFilteredCategories,
                    confirm,
                    setConfirm,
                    apiSettings,
                    posSettings,
                    editCart2,
                    selectCustomer,
                    updateCartCustomerBalance,
                    config,
                    setConfig,
                    productionCenters,
                    iframeMode,
                    activeFlow,
                    setActiveFlow,
                    ordersListVisible,
                    setOrdersListVisible,
                    setTablesListVisible,
                    loadOrders,
                    loadSells,
                    orders,
                    sells,
                    sellsPagination,
                    sellsSearch,
                    setSellsSearch,
                    openOrder,
                    loadNextSplittedOrder,
                    addressPopUpVisible,
                    setAddressPopUpVisible,
                    addressFormPopUpVisible,
                    setAddressFormPopUpVisible,
                    setTablePopup,
                    setSellsListVisible,
                    posCategories,
                    mode,
                    setMode,
                    categoryPos,
                    setCategoryPos,
                    discountsPopup,
                    setDiscountsPopup,
                    editingProduct,
                    setEditingProduct,
                    edited,
                    setEdited,
                    setLoading,
                    setLoadingForced,
                    updateOrder,
                    setSplitPopup,
                    config,
                    setOpenTablePopupVisible,
                    table,
                    setTable,
                    setTableSelectorVisible,
                    editTable,
                    setInvoicePopup,
                    updateOrderFromCart,
                    total,
                    setTotal,
                    deliveryPrice,
                    setDeliveryPrice,
                    setInvoiceFormPopup,
                    invoiceFormPopup,
                    checkout,
                    round,
                    setRound,
                    fiscalPrinters,
                    thermalPrinters,
                    printAgentStatus,
                    thermalPrintAlerts,
                    setReportsPopUpVisible,
                    setPosPaymentPopup,
                    setSatispayPopup,
                    setVoucherlyPopup,
                    checkPermission,
                    hasPosPermission,
                    askPermission,
                    stock,
                    getProductIndex,
                    amount,
                    setAmount,
                    command,
                    setCommand,
                    setOverlay,
                    colors,
                    loadColors,
                    loadingMessage,
                    loadingError,
                    lockEdit,
                    setPaymentPopup,
                    ordersFilter,
                    setOrdersFilter,
                    searchAddressTerm,
                    setSearchAddressTerm,
                    searchTerm,
                    setSearchTerm,
                    setQrPopupVisible,
                    setQrScanPopupVisible,
                    sellsFilter,
                    setSellsFilter,
                    cashDrawerPopupVisible,
                    setCashDrawerPopupVisible,
                    setRestPopup,
                    loadOrderById,
                    fiscalPrinter,
                    setEreciptPopup,
                    setEreciptQrPopup,
                    lastOrderId,
                    fidelityDiscountsPopupVisible,
                    setFidelityDiscountsPopupVisible,
                    points,
                    pointsGained,
                    setPointsGained,
                    pointsSpent,
                    setPointsSpent,
                    toggleSubmenu,
                    menuOpen,
                    setMenuOpen,
                    sendCommand,
                    lightMode,
                    editMode,
                    setEditMode,
                    editProductsPopupVisible,
                    setEditProductsPopupVisible,
                    editCategoriesPopupVisible,
                    setEditCategoriesPopupVisible,
                    listCategoriesPopupVisible,
                    setListCategoriesPopupVisible,
                    loadCategories,
                    categories,
                    listProductsPopupVisible,
                    setListProductsPopupVisible,
                    products,
                    loadProducts,
                    loadMenu: load_menu,
                    refreshOrdersState,
                    selectedEditCategory,
                    setSelectedEditCategory,
                    glories,
                    cashmatics,
                    posP17Terminals,
                    sendLocalCommand,
                    calculateRound,
                    calculateRoundForTotal,
                    calculateTotal,
                    isErecipt,
                    roundNumberByMode,
                    hideFiscalPrinterWarning,
                    setHideFiscalPrinterWarning,
                    setHideCashmaticWarning,
                }}
            >
                {lock ? (
                    <Lock />
                ) : (
                    <>
                        {!user && shops && posSettings?.enable_pin_login != 1 && <Login />}
                        {!user && shops && posSettings?.enable_pin_login == 1 && <PinLogin />}
                        {user && cart && (
                            <div className="main-container">
                                <div className="left">
                                    <Header />
                                    <div className="main">
                                        <Sidebar />
                                        {category && <Products />}
                                    </div>
                                </div>
                                <div className="right">
                                    <HeaderRight />
                                    <Cart />
                                </div>
                                <MainMenu />
                            </div>
                        )}
                        {overlay && (
                            <div className="overlay" onClick={overlay.action ? overlay.action : null}></div>
                        )}
                        {settingsVisible && <Settings />}
                        {addressPopUpVisible && <AddressPopUp />}
                        {addressFormPopUpVisible && <AddressForm />}
                        {ordersListVisible && (
                            <OrdersList
                                onClose={() => setOrdersListVisible(false)}
                                highlightedOrderId={highlightedOrderId}
                                setHighlightedOrderId={setHighlightedOrderId}
                            />
                        )}
                        {tablesListVisible && <TablesList />}
                        {tablePopup && <TablePopUp />}
                        {tableSelectorVisible && <TableSelector order={tableSelectorVisible} />}
                        {openTablePopupVisible && <OpenTablePopup />}
                        {reportsPopUpVisible && <ReportsPopUp />}
                        {discountsPopup && <DiscountsPopup onClose={() => setDiscountsPopup(false)} />}
                        {fidelityDiscountsPopupVisible && <FidelityDiscountsPopup />}
                        {restPopup && <RestPopup />}
                        {editingProduct && <EditProductPopup />}
                        {sellsListVisible && <SellsList />}
                        {invoicePopup && <InvoicePopup />}
                        {popup && (
                            <PopUp
                                options={popup}
                                size={popup.size ? popup.size : ""}
                                customClass={popup.customClass ? popup.customClass : ""}
                            />
                        )}
                        {splitPopup && <SplitPopup options={splitPopup} />}
                        {paymentPopup && <PaymentPopup />}
                        {ereciptPopup && <EreciptPopupPopup />}
                        {ereciptQrPopup && <EreciptQrPopup />}
                        {posPaymentPopup && (
                            <PosPaymentPopup order={posPaymentPopup.data} edit={posPaymentPopup.edit} />
                        )}
                        {satispayPopup && (
                            <SatispayPopup order={satispayPopup.data} edit={satispayPopup.edit} />
                        )}
                        {voucherlyPopup && (
                            <VoucherlyPopup order={voucherlyPopup.data} edit={voucherlyPopup.edit} />
                        )}
                        {cashPaymentPopup && (
                            <CashPaymentPopup
                                order={cashPaymentPopup.data}
                                edit={cashPaymentPopup.edit}
                                previousStatus={cashPaymentPopup.previousStatus}
                            />
                        )}
                        {listCategoriesPopupVisible && <ListCategories />}
                        {editCategoriesPopupVisible && <EditCategories />}
                        {listProductsPopupVisible && <ListProducts />}
                        {editProductsPopupVisible && <EditProducts />}
                        <InventoryPopup />
                        {/* avvisi configurazione + notifiche socket in un'unica colonna, a destra della sidebar */}
                        <div className="bottom-alerts">
                            {showBottomAlerts && (
                                <div className="alerts-row">
                                    <NewOrderAlerts
                                        alerts={newOrderAlerts}
                                        onAlertClick={handleNewOrderAlertClick}
                                    />
                                    {/* <ThermalPrintAlertsPopup alerts={thermalPrintAlerts} /> */}
                                    <UnprintedPopup />
                                    {showFiscalPrinterWarning && <FiscalPrinterPopup />}
                                    {showCashmaticWarning && <CashmaticWarningPopup />}
                                </div>
                            )}
                            <div id="notifications"></div>
                        </div>
                        <GloryPopup />
                        <CashmaticPopup />
                        <FiskalyExpiringLogin />
                        {qrPopupVisible && (
                            <>
                                <div className="overlay" onClick={() => setQrPopupVisible(false)}></div>
                                <QrPopup />
                            </>
                        )}
                        {qrScanPopupVisible && (
                            <>
                                <div className="overlay" onClick={() => setQrScanPopupVisible(false)}></div>
                                <QrScanPopup />
                            </>
                        )}
                        {config.cash_drawer_closures == 1 && <CashDrawerPopup />}
                        {pinPadVisible && (
                            <PinPad
                                onCancel={() => {
                                    pendingAuthorizationActionRef.current = null;
                                    setPinPadVisible(false);
                                }}
                                onSubmit={(pin) => checkPin(pin)}
                            />
                        )}
                        <Confirm />
                        {(loading || loadingForced) && <Loading />}
                        {licenseNoticeVisible && (
                            <div className="license-notice">
                                <span title={shop.license_notice}>{shop.license_notice}</span>
                                <button
                                    type="button"
                                    aria-label="Chiudi"
                                    onClick={() => setDismissedLicenseNotice(licenseNoticeKey)}>
                                    ×
                                </button>
                            </div>
                        )}
                        {licenseExpiredShop && (
                            <div className="expire">
                                <div className="content">
                                    <h3>ATTENZIONE</h3>
                                    Licenza del negozio {shop.name} scaduta da {licenseExpiredDays(shop)}{" "}
                                    {licenseExpiredDays(shop) == 1 ? "giorno" : "giorni"}
                                    <br /> Per il rinnovo dei servizi contatta il commerciale di riferimento
                                    {licenseSwitchableShops.length > 0 && (
                                        <>
                                            <div className="expire-switch-title">Cambia negozio</div>
                                            {licenseSwitchableShops.map((s) => (
                                                <button
                                                    key={s.id}
                                                    type="button"
                                                    className="button button-1"
                                                    onClick={() => switchShopAfterLicenseExpired(s)}>
                                                    {s.name}
                                                </button>
                                            ))}
                                        </>
                                    )}
                                </div>
                            </div>
                        )}
                        {licenseExpiredAllShops && (
                            <div className="expire">
                                <div className="content">
                                    <h3>ATTENZIONE</h3>
                                    Licenza scaduta
                                    <br /> Per il rinnovo dei servizi contatta il commerciale di riferimento
                                </div>
                            </div>
                        )}
                    </>
                )}
                <Updater />
            </AppContext.Provider>
        </>
    );
}

export default App;
